// Idioma base de Fahrtenbuch Pro. Las claves tipadas (I18nKey) derivan de este objeto.
// ES se queda: es el idioma de la propietaria (decisión registrada en PLAN.md).
export const es = {
  "credits.extraShort": "+{count} extra",
  "credits.title": "Créditos de IA adicionales",
  "credits.offer": "100 llamadas de IA · 10 €",
  "credits.description": "Pago único, disponible para todos los usuarios. No caducan. Se utilizan después de las llamadas incluidas en tu plan.",
  "credits.unit": "Un crédito permite extraer un callsheet (documento de rodaje). Los intentos fallidos no descuentan créditos; volver a extraer un documento correctamente sí consume otro.",
  "credits.balance": "Créditos extra disponibles: {count}",
  "credits.balanceUnknown": "Saldo de créditos pendiente de comprobar.",
  "credits.buy": "Comprar 100 créditos por 10 €",
  "credits.opening": "Abriendo pago…",
  "credits.purchaseError": "No se pudo abrir el pago. Inténtalo de nuevo.",
  "credits.confirmed": "Pago confirmado: se han añadido los 100 créditos.",
  "credits.pending": "Estamos pendientes de confirmar el pago. Si ya has pagado, no necesitas comprar de nuevo.",
  "credits.checkPayment": "Comprobar pago",
  "credits.refunded": "Este pago tiene un reembolso. El saldo se ha actualizado.",
  "projects.showTrips": "Mostrar viajes de {name}",
  "projects.moveTripHint": "Arrastra un viaje sobre otro proyecto o elige «Mover a…». Si el origen queda sin viajes ni documentos o gastos independientes, se elimina automáticamente.",
  "projects.noTripsInFilter": "No hay viajes con este filtro.",
  "projects.dragTrip": "Arrastrar viaje del {date}",
  "projects.moveTripLabel": "Mover viaje del {date}",
  "projects.moveTripTo": "Mover a…",
  "projects.moveTripDone": "Viaje trasladado a «{name}».",
  "projects.moveTripRemoved": "El proyecto de origen quedó vacío y se eliminó.",
  "projects.moveTripRetained": "El proyecto de origen conserva documentos o gastos independientes y no se ha eliminado.",
  "projects.moveTripFailed": "No se pudo confirmar el traslado. Actualiza la lista antes de reintentar.",
  "projects.moveTripUnavailable": "El traslado necesita una actualización de la base de datos. No se ha movido el viaje.",
  "bulk.retryLimit": "Has alcanzado el límite de 3 reintentos. Revisa y corrige el documento manualmente.",
  "bulk.retryBusy": "Ya hay una extracción activa para este documento o los dos puestos están ocupados. Espera a que termine una antes de reintentar.",
  "bulk.retryDocument": "Reintentar extracción",
  "bulk.retryDocumentConfirm": "¿Reintentar la extracción de «{name}» usando el archivo ya subido? Si termina correctamente, consumirá una extracción de tu cuota.",
  "bulk.queueStartFailed": "Los archivos están guardados, pero no se pudo confirmar el inicio de la cola. Vuelve a abrir esta ventana para continuar.",
  "bulk.backgroundProcessing": "Puedes cerrar esta ventana: los documentos subidos siguen procesándose en segundo plano. Los fallos no se reintentan automáticamente.",
  "bulk.waitForUpload": "Espera a que termine la subida y se confirme el inicio del lote.",
  "bulk.deleteDocument": "Eliminar",
  "bulk.deleteDocumentLabel": "Eliminar documento {name}",
  "bulk.deleteDocumentConfirm": "¿Eliminar \"{name}\" y su archivo original? Esta acción no se puede deshacer.",
  "bulk.documentDeleted": "Documento eliminado.",
  "bulk.deleteDocumentError": "No se pudo eliminar el documento. Sigue disponible para volver a intentarlo.",
  "plans.checking": "Comprobando suscripción…",
  "plans.unavailable": "No se ha podido comprobar tu suscripción. Vuelve a intentarlo; no necesitas comprar otro plan.",
  "plans.statusUnavailable": "Suscripción sin verificar",
  "ui.csvRows": "CSV: incluye cabeceras y al menos una fila.",
  "ui.batchMax": "Máximo {count} documentos por vez",
  "ui.uploaded": "Se subieron {count} documentos",
  "ui.uploadedProcess": "Se subieron {count} documentos. Pulsa \"Procesar ahora\" para empezar.",
  "ui.uploadFailedCount": "Fallaron {count} documentos",
  "ui.cancelledCount": "Procesamiento cancelado ({count} trabajos)",
  "ui.startingCount": "Iniciando extracción de {count} documento(s)…",
  "ui.processedTrips": "Viajes procesados ({count})",
  "ui.projectCreatedNamed": "Proyecto \"{name}\" creado",
  "ui.createdViaTrip": "Creado desde un viaje",
  "ui.calendarImport": "Importado de Google Calendar",
  "ui.rowDate": "Fila {row}: fecha inválida",
  "ui.rowProject": "Fila {row}: nombre de proyecto vacío",
  "ui.rowAddress": "Fila {row}: origen/destino vacíos (y no hay dirección base)",
  "ui.rowKm": "Fila {row}: kilómetros inválidos",
  "ui.rowStops": "Fila {row}: demasiadas paradas",
  "ui.partialDelete": "Se borraron {ok}/{total}. {failed} fallaron (no se borró todo lo asociado).",
  "ui.totalsUnavailable": "No se pueden cargar los totales de los proyectos. Contacta con soporte.",
  "ui.projectExistsNamed": "El proyecto \"{name}\" ya existe",
  "ui.reportLimit": "Has alcanzado el límite de informes de tu plan.",
  "ui.invalidTrip": "Datos del viaje inválidos. {issues}",
  "ui.profileSaving": "Guardando…",
  "ui.profileSaved": "Perfil guardado",
  "ui.profileFailed": "No se pudo guardar el perfil.",
  "ui.emptyFile": "{name}: el archivo está vacío.",
  "ui.largeFile": "{name}: supera los 50 MB por archivo.",
  "ui.unclosedQuotes": "Hay una celda con comillas sin cerrar. Revisa el texto antes de guardar.",
  "ui.duplicateColumns": "Hay columnas con el mismo nombre. Renómbralas antes de importar.",
  "ui.damagedOffice": "El documento Office está dañado.",
  "ui.complexOffice": "Este documento Office es demasiado complejo. Divídelo en varios archivos.",
  "ui.expandedOffice": "El documento Office contiene demasiados datos descomprimidos. Divídelo en varios archivos.",
  "ui.spreadsheetType": "{name}: selecciona CSV, TSV o Excel (.xlsx, .xls).",
  "ui.invalidWorkbook": "{name}: no es un libro Excel válido.",
  "ui.noSheets": "{name}: no hay hojas visibles con datos.",
  "ui.invalidLogin": "Email o contraseña incorrectos.",
  "ui.unexpected": "Ha ocurrido un error. Vuelve a intentarlo.",
  "ui.googleConfiguration": "No se pudo conectar con Google. Vuelve a intentarlo o contacta con soporte.",
  "ui.security": "Seguridad",
  "ui.passwordHint": "Establece o actualiza tu contraseña para iniciar sesión con email.",
  "ui.changePassword": "Cambiar contraseña",
  "ui.geminiDefault": "Gemini IA (predeterminado)",
  "ui.model": "Modelo de OpenRouter",
  "ui.selectModel": "Selecciona un modelo",
  "ui.loadingModels": "Cargando modelos...",
  "ui.visionModels": "Estos modelos admiten el reconocimiento de imágenes y PDF.",
  "ui.lastExtraction": "Última extracción IA",
  "ui.checkingProvider": "Comprobando proveedor usado...",
  "ui.provider": "Proveedor:",
  "ui.modelLabel": "Modelo:",
  "ui.actualProvider": "Proveedor real:",
  "ui.date": "Fecha:",
  "ui.noExtraction": "Todavía no hay una extracción registrada con proveedor visible.",
  "ui.disconnect": "Desconectar",
  "ui.changelog": "Historial de cambios",
  "ui.noUpdates": "No hay un canal de actualizaciones configurado aún.",
  "ui.noChangelog": "El historial de cambios todavía no está publicado dentro de la app.",
  "ui.noSupport": "El canal de soporte aún no está configurado.",
  "ui.uploadCallsheet": "Subir callsheet",
  "ui.deleteCallsheet": "¿Estás seguro de eliminar esta hoja de llamada? Se borrarán los datos asociados.",
  "ui.alreadyProcessing": "El documento ya se está procesando",
  "ui.reprocess": "Este documento ya fue procesado. ¿Quieres volver a procesarlo? Consumirá otra extracción de tu cuota.",
  "ui.quotaPreserved": "No queda cuota disponible. Se conservan el documento y los resultados anteriores.",
  "ui.quotaUnavailable": "No se pudo comprobar tu cuota. El documento se conserva; inténtalo de nuevo más tarde.",
  "ui.processingCancelled": "Procesamiento cancelado; documento conservado",
  "ui.noPendingDocuments": "No hay documentos pendientes por procesar",
  "ui.reviewProcessed": "Revisa los viajes extraídos automáticamente y guárdalos todos juntos",
  "ui.processAI": "Procesar con IA",
  "ui.producerExample": "Ej. Productora XY",
  "ui.loading": "Cargando…",
  "ui.templateExample": "Ej. Visita cliente X",
  "ui.routeRequired": "La ruta debe tener origen y destino",
  "ui.templateFailed": "Error al guardar plantilla",
  "ui.dateRequired": "Selecciona una fecha",
  "ui.fillRoute": "Completa origen y destino",
  "ui.commands": "Comandos",
  "ui.commandHint": "Buscar y ejecutar comandos",
  "ui.noRecentTrips": "No hay viajes recientes.",
  "ui.offline": "Sin conexión. La app puede mostrar datos guardados, pero no podrás sincronizar cambios hasta recuperar internet.",
  "ui.captchaFailed": "No se pudo completar la verificación de seguridad. Comprueba tu conexión.",
  "ui.retry": "Reintentar",
  "ui.emissionsLoading": "Cargando datos de emisiones...",
  "ui.maxStops": "Máximo 8 paradas intermedias",
  "ui.templateRouteRequired": "La plantilla necesita origen y destino",
  "ui.deleteStop": "Eliminar parada",
  "ui.projectDeleteFailed": "No se pudo borrar el proyecto.",
  "ui.projectExists": "Ya existe un proyecto con ese nombre",
  "ui.projectUpdated": "Proyecto actualizado",
  "ui.projectCreated": "Proyecto creado",
  "ui.tripDeleteFailed": "No se pudo borrar el viaje.",
  "ui.tripUpdateFailed": "No se pudo actualizar el viaje. Se conserva el anterior.",
  "ui.distance": "Distancia:",
  "ui.eventTitleRequired": "Escribe un título para el evento",
  "ui.eventDates": "Revisa la fecha y hora de inicio/fin",
  "ui.eventEnd": "La hora de fin debe ser posterior a la de inicio",
  "ui.eventCreated": "Evento creado",
  "ui.enterEmail": "Introduce tu email",
  "ui.recoveryEmailHint": "Escribe tu email arriba para enviarte un enlace de recuperación.",
  "ui.emailSent": "Email enviado",
  "ui.checkInbox": "Revisa tu bandeja de entrada para restablecer la contraseña.",
  "ui.sendFailed": "No se pudo enviar",
  "ui.googleFailed": "No se pudo iniciar sesión con Google",
  "ui.passwordUpdated": "Contraseña actualizada",
  "ui.newPasswordLogin": "Ya puedes iniciar sesión con tu nueva contraseña.",
  "ui.authError": "Error de autenticación",
  "ui.noGoogleResponse": "No se recibió respuesta de Google",
  "ui.retryLogin": "Vuelve a intentarlo desde la pantalla de acceso.",
  "ui.loginFailed": "No se pudo completar el inicio de sesión",
  "ui.checkGoogleSetup": "Revisa la configuración de Google en Supabase.",
  "ui.invalidSession": "Sesión no válida",
  "ui.sessionFailed": "No se pudo recuperar la sesión tras el login.",
  "ui.verifyingAuth": "Verificando la autenticación…",
  "ui.invalidLink": "Enlace no válido",
  "ui.newRecoveryEmail": "Solicita un nuevo correo para restablecer tu contraseña.",
  "ui.backLogin": "Volver al acceso",
  "ui.backLogin2": "Volver al acceso",
  "ui.secureReset": "Restablecimiento seguro",
  "ui.confirmReset": "Confirma que quieres continuar para crear una nueva contraseña de Fahrtenbuch Pro.",
  "ui.anotherLink": "Solicitar otro enlace",
  "ui.continueSecure": "Continuar de forma segura",
  "ui.verificationSlow": "La verificación está tardando demasiado. Comprueba tu conexión e inténtalo de nuevo.",
  "ui.expiredLink": "Este enlace ha caducado o ya fue utilizado. Solicita un nuevo correo de recuperación.",
  "ui.verifyLinkFailed": "No se pudo verificar el enlace. Solicita un nuevo correo de recuperación.",
  "ui.supabaseMissing": "Supabase no configurado",
  "ui.supabaseEnvMissing": "Faltan variables de entorno de Supabase.",
  "ui.sessionMissing": "Sesión no encontrada",
  "ui.openRecoveryEmail": "Abre el enlace de recuperación desde tu email.",
  "ui.passwordMismatch": "Las contraseñas no coinciden",
  "ui.passwordShort": "Contraseña demasiado corta",
  "ui.passwordMin": "Usa al menos 8 caracteres.",
  "ui.passwordEmailLogin": "Ya puedes iniciar sesión con email y contraseña.",
  "ui.updateFailed": "No se pudo actualizar",
  "ui.checkCurrentPassword": "Comprueba tu contraseña actual e inténtalo de nuevo.",
  "ui.unexpectedError": "Error inesperado",
  "ui.resetPassword": "Restablecer contraseña",
  "ui.recoverySessionHint": "Abre el enlace de recuperación que te enviamos por email. Si ya lo abriste y llegaste aquí sin sesión, vuelve a intentarlo.",
  "ui.verificationNeeded": "Verificación necesaria",
  "ui.startSecureChange": "Inicia el cambio desde Ajustes o utiliza el enlace seguro enviado a tu correo.",
  "ui.backDashboard": "Volver al panel",
  "ui.secureLinkSent": "Enlace de seguridad enviado",
  "ui.openSecureEmail": "Abre el correo para establecer una contraseña de forma segura.",
  "ui.linkSendFailed": "No se pudo enviar el enlace",
  "ui.retryLater": "Espera unos minutos e inténtalo de nuevo.",
  "ui.setPassword": "Establecer contraseña",
  "ui.externalAccount": "Tu cuenta utiliza un proveedor externo. Para protegerla, te enviaremos un enlace de un solo uso a tu correo verificado.",
  "ui.sendSecureLink": "Enviar enlace seguro",
  "ui.newPassword": "Nueva contraseña",
  "ui.choosePassword": "Elige una contraseña nueva para tu cuenta.",
  "ui.currentPassword": "Contraseña actual",
  "ui.password": "Contraseña",
  "ui.confirmPassword": "Confirmar contraseña",
  "ui.save": "Guardar",
  "ui.errorTitle": "Algo ha fallado",
  "ui.errorBody": "La app encontró un error inesperado. Puedes recargar o volver a intentarlo.",
  "ui.reload": "Recargar",
  "ui.errorSupport": "Si el problema persiste, revisa tu conexión o contacta con soporte.",
  "ui.reloadConfirm": "Se recargará esta pestaña. Los cambios sin guardar se perderán. ¿Continuar?",
  "ui.callsheetUploadFailed": "Error al subir callsheet",
  "ui.home": "Inicio",

  "modal.close": "Cerrar",
  "modal.addDocuments": "Añadir documentos",
  "modal.addExpense": "Añadir gasto",
  "modal.details": "Datos del viaje",
  "modal.noTrips": "Este proyecto todavía no tiene viajes.",
  "modal.options": "Opciones del viaje",
  "modal.uploadHelp": "Formatos y límites",
  "modal.select": "Seleccionar",
  "modal.process": "Procesar",
  "modal.review": "Revisar",
  "modal.files": "Archivos",
  "modal.text": "Pegar texto",
  "modal.vehicle": "Vehículo",
  "modal.costs": "Tarifas y costes",
  "modal.security": "Seguridad",
  "modal.integrations": "Integraciones",
  "modal.summary": "Resumen",
  "modal.documents": "Documentos",
  "modal.calculate": "Calcular distancia",
  "modal.uploadLimit": "Hasta {count} archivos · 50 MB por archivo",
  "modal.batchReview": "Abre un documento para comprobar sus datos y su ruta.",
  "callsheetReview.deletePartial": "Se eliminaron {deleted} elementos. No se pudieron eliminar {failed}; siguen seleccionados para reintentar.",
  "tripDetail.editInvalid": "Comprueba la fecha, completa todas las direcciones e introduce distancias e importes válidos.",
  "tripDetail.editInvalidDocument": "Comprueba la fecha y conserva al menos una localización válida. Completa o elimina las localizaciones vacías. Los kilómetros, pasajeros y gastos son opcionales; si los introduces, deben ser válidos.",
  "callsheetReview.title": "Revisar",
  "callsheetReview.description": "Datos extraídos pendientes de confirmar.",
  "callsheetReview.detectedDate": "Fecha detectada",
  "callsheetReview.incompleteDate": "Fecha por completar o confirmar",
  "callsheetReview.checkData": "Revisar datos detectados",
  "callsheetReview.details": "Ver detalles",
  "callsheetReview.open": "Ver documento",
  "callsheetReview.edit": "Completar viaje",
  "callsheetReview.loadError": "No se pudieron cargar los documentos pendientes de revisión. Vuelve a intentarlo.",
  "callsheetReview.retry": "Reintentar",

  "updates.available": "Nueva versión disponible",
  "updates.description": "Actualiza cuando hayas guardado tu trabajo. Las otras pestañas seguirán abiertas.",
  "updates.action": "Actualizar",
  "updates.closeEditor": "Guarda o cierra el formulario abierto antes de actualizar.",
  "updates.confirm": "Se recargará esta pestaña. Los cambios sin guardar se perderán. ¿Continuar?",
  "updates.failed": "No se pudo activar la actualización. Tu pestaña sigue abierta; vuelve a intentarlo.",
  "expenseScan.deleteConfirm": "Este recibo se eliminará definitivamente",
  "expenseScan.deleteRecoveryError": "No se pudo completar el borrado ni restablecer el vínculo del recibo. No se ha confirmado su eliminación. Recarga el viaje o proyecto y contacta con soporte si sigue faltando.",
  "uploads.invalidNameTitle": "Nombre de archivo no válido",
  "uploads.invalidNameBody": "«{name}» contiene separadores de carpetas o caracteres de control. Selecciona un archivo con un nombre válido.",
  "uploads.fileNameHint": "Puedes conservar los nombres originales, incluidos #, acentos y espacios.",
  "uploads.ownershipError": "No se pudo verificar que este archivo pertenece a tu cuenta. Comprueba su nombre y vuelve a subirlo desde tu sesión. Si vuelve a fallar, contacta con soporte.",
  "uploads.callsheetFormats": "PDF, JPG/JPEG, PNG, WebP, HEIC/HEIF, Excel (XLSX/XLS), CSV, TSV, TXT y Word (DOCX).",
  "uploads.callsheetLimits": "Hasta {count} archivos por lote y 50 MB por archivo. El proveedor de IA puede aplicar límites de páginas, contenido o tiempo.",
  "bulk.manualReview": "Revisa y corrige las filas antes de guardar. Sin kilómetros indicados se guardará 0; puedes corregirlo en Viajes.",
  "bulk.removeFile": "Quitar archivo",
  "bulk.removeRow": "Quitar fila",
  "bulk.rows": "filas",
  "bulk.manualDuplicates": "Se omitieron {count} viajes duplicados o ya guardados.",
  "bulk.manualDropHint": "Arrastra CSV o Excel aquí, o pulsa para seleccionar. Hasta 50 MB por archivo.",
  "bulk.saveManual": "Guardar viajes revisados",
  "bulk.reviewPastedCsv": "Revisar CSV pegado",
  "bulk.aiPasteLabel": "Texto de un correo o mensaje",
  "bulk.aiPasteHint": "Pega aquí el contenido que quieres extraer…",
  "bulk.aiAddText": "Añadir texto a la lista",
  "bulk.aiTextQuotaHint": "Cada texto añadido cuenta como un documento. La cuota se consume al procesarlo con IA.",
  "uploads.callsheetConversion": "Para correos y mensajes, pega el texto en la pestaña IA. No necesitas descargar un archivo de correo.",
  "bulk.csvExcelHint": "CSV, TSV y Excel (.xlsx, .xls). Se leen las hojas visibles; revisa las filas antes de guardar. No consume IA.",
  "expenseScan.fileHint": "Imágenes de hasta 10 MB, una por selección. Puedes añadir varios recibos al mismo gasto. Este escáner no admite PDF.",
  "common.comingSoon": "Próximamente",
  // Nav / layout
  "nav.dashboard": "Panel de control",
  "nav.trips": "Viajes",
  "nav.projects": "Proyectos",
  "nav.reports": "Informes",
  "nav.calendar": "Calendario",
  "nav.advanced": "Avanzado",
  "nav.settings": "Ajustes",
  "nav.menu": "Menú",
  "nav.expand": "Expandir",
  "nav.collapse": "Contraer",

  "nav.logout": "Cerrar sesión",

  // Dashboard
  "dashboard.welcomeBack": "Bienvenido/a de nuevo, {name}",
  "dashboard.welcomeBackPrefix": "Hola,",
  "dashboard.greetingMorning": "Buenos días,",
  "dashboard.greetingAfternoon": "Buenas tardes,",
  "dashboard.greetingEvening": "Buenas noches,",
  "dashboard.subtitle": "Aquí tienes el resumen de kilometraje de este mes",
  "dashboard.totalDistance": "Distancia total",
  "dashboard.activeProjects": "Proyectos activos",
  "dashboard.co2Emissions": "Emisiones CO₂",
  "dashboard.thisMonthVsPrevious": "este mes vs el anterior",
  "dashboard.vsLastMonth": "vs el mes anterior",
  "dashboard.viewTrips": "Ver viajes",
  "dashboard.viewProjects": "Ver proyectos",
  "dashboard.viewCo2": "Ver CO₂",
  "dashboard.thisMonth": "Este mes",
  "dashboard.lastMonth": "Mes anterior",
  "dashboard.trend": "Tendencia",
  "dashboard.totalKm": "Km totales",
  "dashboard.status": "Estado",
  "dashboard.equivalentTrees": "Árboles equivalentes",
  "dashboard.equivalentTreesTooltip": "Equivalencia ilustrativa: unos 21 kg de CO₂ por árbol maduro durante un año. Varía según especie y condiciones; no representa una compensación real.",
  "dashboard.excellent": "Excelente",
  "dashboard.good": "Bueno",
  "dashboard.improvable": "Mejorable",
  "dashboard.warnings": "Advertencias",
  "dashboard.noWarnings": "No hay advertencias",
  "tripWarning.invalidDate": "Fecha inválida",
  "tripWarning.noDate": "Sin fecha",
  "tripWarning.incompleteRoute": "Ruta incompleta",
  "tripWarning.missingOriginDestination": "Faltan origen/destino",
  "tripWarning.zeroDistance": "Distancia 0 km",
  "tripWarning.noDistance": "Sin distancia",
  "tripWarning.improbableDistance": "Distancia improbable",
  "tripWarning.noProject": "Sin proyecto",
  "tripWarning.assignProject": "Asigna un proyecto para agrupar y reportar",
  "tripWarning.duplicateTrip": "Viaje duplicado",
  "tripWarning.sameDateAndRoute": "Misma fecha y ruta",

  // Trips
  "trips.title": "Viajes",
  "trips.subtitle": "Gestiona y controla todos tus viajes de empresa",
  "trips.delete": "Eliminar",
  "trips.bulkUpload": "Carga masiva",
  "trips.addTrip": "Añadir viaje",
  "trips.project": "Proyecto",
  "trips.allProjects": "Todos los proyectos",
  "trips.all": "Todo",
  "trips.year": "Año",
  "trips.date": "Fecha",
  "trips.route": "Ruta",
  "trips.co2": "CO₂",
  "trips.passengers": "Pasajeros",
  "trips.reimbursement": "Reembolso",
  "trips.expenses": "Gastos",
  "trips.receipts": "Facturas",
  "trips.totalCost": "Coste total",
  "trips.distance": "Distancia",
  "trips.viewMap": "Ver mapa",
  "trips.addToCalendar": "Añadir al calendario",
  "trips.edit": "Editar",
  "trips.showing": "Mostrando {count} viajes",
  "trips.of": "de",
  "trips.loadMore": "Cargar más",
  "trips.total": "Total: {km} km",
  "trips.sortByDate": "Ordenar por fecha ({order})",
  "trips.sortAsc": "ascendente",
  "trips.sortDesc": "descendente",
  "trips.toastAddedToCalendarTitle": "Añadido al calendario",
  "trips.toastAddedToCalendarBody": "Viaje a {destination} el {date} añadido al calendario.",
  "trips.toastTripsDeletedTitle": "Viajes eliminados",
  "trips.toastTripsDeletedBody": "Se eliminaron {count} viaje(s).",
  "trips.toastTripCreatedTitle": "Viaje guardado",
  "trips.toastTripCreatedBody": "El viaje se guardó correctamente.",
  "trips.continuation": "Continuación",
  "trips.returnTrip": "Fin continuación",
  "trips.toastTripUpdatedTitle": "Viaje actualizado",
  "trips.toastTripUpdatedBody": "Los cambios se guardaron correctamente.",
  "trips.calendarNotConnected": "Google Calendar no está conectado. Conéctalo en Ajustes > APIs.",
  "trips.selectTrip": "Seleccionar viaje {id}",

  // Projects
  "projects.title": "Proyectos",
  "projects.subtitle": "Organiza los viajes por proyecto para crear informes fácilmente",
  "projects.delete": "Eliminar",
  "projects.newProject": "Nuevo proyecto",
  "projects.createNewProject": "Crear nuevo proyecto",
  "projects.projectName": "Nombre del proyecto",
  "projects.company": "Empresa / Cliente",
  "projects.companyPlaceholder": "Nombre de la empresa",
  "projects.description": "Descripción",
  "projects.descriptionPlaceholder": "Descripción breve del proyecto",
  "projects.ratePerKm": "Tarifa por km (€)",
  "projects.ratePerPassenger": "Tarifa por pasajero (€)",
  "projects.createProject": "Crear proyecto",
  "projects.filterProducer": "Productora",
  "projects.searchPlaceholder": "Buscar proyectos...",
  "projects.year": "Año",
  "projects.allTime": "Todo el tiempo",
  "projects.selectAll": "Seleccionar todo",
  "projects.tableDate": "Fecha",
  "projects.tableProject": "Proyecto",
  "projects.tableCompany": "Empresa / Productora / Cliente",
  "projects.tableTrips": "Viajes",
  "projects.tableTotalKm": "Distancia total",
  "projects.tableCo2": "CO₂ (kg)",
  "projects.tableDocuments": "Documentos / Callsheets",
  "projects.tableInvoices": "Factura",
  "projects.tableCost": "Reembolso",
  "projects.viewDetails": "Ver detalles",
  "projects.edit": "Editar",
  "projects.emptyTitle": "No se encontraron proyectos",
  "projects.emptyTryAdjust": "Prueba a ajustar la búsqueda",
  "projects.emptyCreateFirst": "Crea tu primer proyecto para empezar",
  "projects.summaryCount": "{count} proyectos",
  "projects.summaryTotal": "Total: {km} km",
  "projects.toastDeletedTitle": "Proyectos eliminados",
  "projects.toastDeletedBody": "Se eliminaron {count} proyecto(s).",
  "projects.selectProject": "Seleccionar proyecto {name}",

  // Add/Edit Trip Modal
  "tripModal.addTitle": "Añadir viaje",
  "tripModal.editTitle": "Editar viaje",
  "tripModal.date": "Fecha",
  "tripModal.project": "Proyecto",
  "tripModal.selectProject": "Selecciona proyecto",
  "tripModal.route": "Ruta",
  "tripModal.addStop": "Añadir parada",
  "tripModal.specialOrigin": "Origen especial",
  "tripModal.specialOriginBase": "Salida desde mi dirección base",
  "tripModal.specialOriginContinue": "Continuar desde el último destino",
  "tripModal.specialOriginReturn": "Regresar a mi dirección base (desde el último destino)",
  "tripModal.passengers": "Pasajeros",
  "tripModal.fuelLiters": "Combustible (L)",
  "tripModal.evKwhUsed": "Consumo eléctrico (kWh)",
  "tripModal.distance": "Distancia (km)",
  "tripModal.rate": "Tarifa de viaje (€/km)",
  "tripModal.purpose": "Motivo",
  "tripModal.purposePlaceholder": "Motivo del viaje",
  "tripModal.toll": "Peaje (€)",
  "tripModal.parking": "Parking (€)",
  "tripModal.otherExpenses": "Otros (€)",
  "tripModal.fuel": "Combustible (€)",
  "tripModal.save": "Guardar viaje",
  "tripModal.update": "Actualizar viaje",
  "tripModal.origin": "Origen",
  "tripModal.destination": "Destino",
  "tripModal.stop": "Parada",
  "tripModal.originPlaceholder": "Ubicación de origen",
  "tripModal.destinationPlaceholder": "Ubicación de destino",
  "tripModal.stopPlaceholder": "Parada intermedia",
  "tripModal.projectSearchPlaceholder": "Buscar o crear proyecto...",
  "tripModal.projectNotFound": "No encontrado.",
  "tripModal.createProjectNamed": "Crear \"{name}\"",
  "tripModal.useAsClient": "Usar \"{name}\" como cliente",

  // Calendar page
  "calendar.title": "Calendario",
  "calendar.subtitle": "Sincroniza eventos de Google Calendar",
  "calendar.refresh": "Actualizar",
  "calendar.connectGoogle": "Conectar Google",
  "calendar.calendars": "Calendarios",
  "calendar.notConnected": "No conectado",
  "calendar.notConnectedBody": "Conecta tu Google Calendar para sincronizar eventos y crear viajes desde entradas del calendario.",
  "calendar.connect": "Conectar",
  "calendar.disconnect": "Desconectar",
  "calendar.insufficientPermissionsTitle": "Permisos insuficientes",
  "calendar.insufficientPermissionsBody": "Se necesita actualizar los permisos de Google Calendar para listar tus calendarios. Desconecta y vuelve a conectar.",
  "calendar.reconnect": "Reconectar",
  "calendar.createEventTitle": "Crear evento",
  "calendar.eventTitleLabel": "Título",
  "calendar.eventTitlePlaceholder": "Reunión / viaje / recordatorio",
  "calendar.calendarLabel": "Calendario",
  "calendar.selectCalendarPlaceholder": "Selecciona un calendario",
  "calendar.startLabel": "Inicio",
  "calendar.endLabel": "Fin",
  "calendar.cancel": "Cancelar",
  "calendar.creating": "Creando...",
  "calendar.create": "Crear",
  "calendar.loading": "Cargando...",
  "calendar.more": "+{count} más",
  "calendar.weekdays": "Lun,Mar,Mié,Jue,Vie,Sáb,Dom",
  "calendar.importEventTitle": "Importar evento como viaje",
  "calendar.importEventDescription": "Crear un viaje basado en este evento de calendario",
  "calendar.eventLocation": "Ubicación",
  "calendar.eventDescription": "Descripción",
  "calendar.importWillCreate": "Se creará un viaje con:",
  "calendar.importClientFromTitle": "Cliente/Empresa: título del evento",
  "calendar.importRouteFromBase": "Ruta: desde dirección base (ida y vuelta)",
  "calendar.importProjectManual": "Proyecto: configurado como 'Unknown' (editable después)",
  "calendar.importDistanceCalculated": "Distancia: calculada automáticamente",
  "calendar.viewInGoogle": "Ver en Google",
  "calendar.importAsTrip": "Importar como viaje",
  "calendar.importing": "Importando...",
  "calendar.importSuccess": "Viaje importado exitosamente",
  "calendar.importError": "No se pudo importar el evento",
  "calendar.importNoLocations": "No se encontraron ubicaciones en el evento. Agrega una ubicación o descripción con origen y destino.",
  "calendar.importNoDistance": "No se pudo calcular la distancia. Verifica las ubicaciones.",
  "calendar.importNeedBaseAddress": "Completa tu dirección base, ciudad y país en Ajustes antes de importar el evento.",

  // Advanced
  "advanced.title": "Avanzado",
  "advanced.subtitle": "Herramientas avanzadas y análisis",
  "advanced.routesTitle": "Plantillas de rutas",
  "advanced.routesBody": "Gestiona tus rutas frecuentes y plantillas predefinidas",
  "advanced.costsTitle": "Análisis de costes",
  "advanced.costsBody": "Análisis de gastos, combustible y mantenimiento",
  "advanced.emissionsTitle": "Emisiones CO₂",
  "advanced.emissionsBody": "Seguimiento de huella de carbono y eficiencia ambiental",



  // Auth
  "auth.tagline": "Seguimiento profesional de kilometraje",
  "auth.featureTrips": "🚗 Registra cada viaje",
  "auth.featureTripsBody": "Registra distancias automáticamente con GPS o con extracción con IA desde callsheets.",
  "auth.featureReports": "📊 Genera informes",
  "auth.featureReportsBody": "Crea informes listos para descargar e imprimir.",
  "auth.featureImport": "🤖 Importación con IA",
  "auth.featureImportBody": "Extrae datos de viajes automáticamente desde PDFs, imágenes y callsheets.",
  "auth.login": "Iniciar sesión",
  "auth.signUp": "Registrarse",
  "auth.pleaseSignIn": "Por favor inicia sesión",
  "auth.fullName": "Nombre completo",
  "auth.password": "Contraseña",
  "auth.forgotPassword": "¿Olvidaste la contraseña?",
  "auth.createAccount": "Crear cuenta",
  "auth.verifyEmailTitle": "Verifica tu correo",
  "auth.verifyEmailBody": "Te enviamos un email para verificar tu cuenta. Revisa tu bandeja de entrada (y spam).",
  "auth.orContinueWith": "O continúa con",
  "auth.continueWithGoogle": "Continuar con Google",
  "auth.byContinuing": "Al continuar, aceptas nuestros",
  "auth.and": "y",
  "auth.terms": "Términos del servicio",
  "auth.privacy": "Política de privacidad",
  "auth.heroTitle": "Tu kilometraje, en piloto automático.",
  "auth.heroBullet1": "Sube la callsheet del día de rodaje",
  "auth.heroBullet2": "La IA crea los viajes con ruta y km",
  "auth.heroBullet3": "Informe PDF mensual para producción",
  "auth.heroFooter": "Crew de cine y TV en Austria · rodajes en DE, CZ y HU",
  "auth.heroCardTitle": "Liquidación de kilometraje",
  "auth.heroCardMeta": "Junio 2026 · 26 viajes · 3 recibos",
  "auth.heroCardTotalLabel": "TOTAL JUNIO",
  "auth.welcomeBackTitle": "Inicia sesión",
  "auth.welcomeBackSubtitle": "Accede a tu cuenta existente.",
  "auth.createAccountTitle": "Crea tu cuenta",
  "auth.createAccountSubtitle": "Empieza gratis. Sin tarjeta.",
  "auth.googleAccountNotFoundTitle": "Esta cuenta todavía no existe",
  "auth.googleAccountNotFoundBody": "Para registrarte, pulsa «Empieza gratis» y continúa con Google.",
  "auth.googleAccountCheckFailed": "No se pudo comprobar la cuenta de Google. Inténtalo de nuevo.",
  "auth.orWithEmail": "o con tu correo",
  "auth.noAccount": "¿No tienes cuenta?",
  "auth.startFree": "Empieza gratis",
  "auth.haveAccount": "¿Ya tienes cuenta?",
  "auth.email": "Correo electrónico",
  "auth.emailPlaceholder": "tu@correo.com",
  "auth.showPassword": "Mostrar contraseña",
  "auth.hidePassword": "Ocultar contraseña",

  // Not found
  "notFound.message": "¡Ups! Página no encontrada",
  "common.allCompanies": "Todas las empresas",
  "notFound.returnHome": "Volver al inicio",

  // Misc / charts
  "chart.kmByProject": "Kilómetros por proyecto",
  "chart.kmByWeek": "Kilómetros por semana",
  "chart.kmByMonth": "Kilómetros por mes",
  "chart.kmByYear": "Kilómetros por año",
  "chart.distance": "Distancia",
  "chart.filterProject": "Proyecto",
  "chart.filterAll": "Todo",
  "chart.filterWeek": "Semana",
  "chart.filterMonth": "Mes",
  "chart.filterYear": "Año",
  "chart.filterAllProjects": "Todos",
  "chart.noData": "Sin datos para mostrar",
  "dashboard.recentTrips": "Viajes recientes",
  "dashboard.viewAll": "Ver todos",
  "bulk.aiExtraction": "Extracción IA",
  "bulk.title": "Asistente de carga masiva",
  "bulk.subtitle": "Importa viajes desde CSV o Excel, o extrae documentos y mensajes con IA.",
  "bulk.tabCsv": "CSV / Excel · Manual",
  "bulk.tabAi": "Extracción IA",
  "bulk.csvInstructionsTitle": "Instrucciones de importación CSV",
  "bulk.csvInstructionsRequired": "Cabeceras requeridas: 'date', 'projectName', 'origin', 'destination'. Opcionales: 'reason', 'distance', y 'cliente'/'empresa'/'productora'.",
  "bulk.csvInstructionsStops": "Las columnas entre 'origin' y 'destination' (en el orden del CSV) se tratan como paradas intermedias. Las columnas 'cliente'/'empresa'/'productora' se usan como metadatos del proyecto. Si 'origin' o 'destination' están vacías, se usará tu dirección base por defecto.",
  "bulk.csvInstructionsSeparator": "El archivo puede estar separado por comas (,) o punto y coma (;). El importador lo detectará automáticamente.",
  "bulk.selectCsvFile": "Seleccionar CSV o Excel",
  "bulk.importFromDrive": "Importar de Google Drive",
  "bulk.drivePickerTitle": "Selecciona un CSV en Google Drive",
  "bulk.drivePickerTitlePdf": "Selecciona PDFs en Google Drive",
  "bulk.drivePickerTitleCallsheets": "Selecciona callsheets en Google Drive (PDF o imagen)",
  "bulk.downloadingFromDrive": "Descargando desde Drive...",
  "bulk.importPdfFromDrive": "Importar PDFs de Google Drive",
  "bulk.errorDrivePickerNotConfigured": "Falta configurar el selector de Drive (VITE_GOOGLE_PICKER_API_KEY).",
  "bulk.or": "o",
  "bulk.pasteCsv": "Pegar texto CSV",
  "bulk.processPasted": "Procesar texto pegado",
  "bulk.cancel": "Cancelar",
  "bulk.toastProcessingCancelled": "Extraccion cancelada al cerrar el modal.",
  "bulk.aiCancelExtraction": "Cancelar extracción",
  "bulk.toastBackgroundProcessing": "La extracción sigue en segundo plano. Reabre el asistente para revisarla.",
  "bulk.aiDropTitle": "Arrastra documentos aquí",
  "bulk.aiDropSubtitle": "Hojas de rodaje en PDF o imágenes (JPG/JPEG, PNG, WebP, HEIC y HEIF)",
  "bulk.aiChangeFilesHint": "Pulsa o arrastra más archivos para añadirlos.",
  "bulk.aiFilesSelected": "{count} archivos seleccionados",
  "bulk.aiDescription": "Sube tus hojas de rodaje (call sheets) en PDF o como foto. La IA extraerá automáticamente fechas, ubicaciones, proyecto y distancias.",
  "bulk.aiDisclaimer": "La IA puede cometer errores. Es responsabilidad del usuario revisar que la información extraída sea correcta antes de guardar.",
  "bulk.aiProcessingTitle": "Analizando documentos...",
  "bulk.aiProcessingHint": "Esto puede tardar unos segundos.",
  "bulk.aiProcessingProgress": "Completados {done}/{total} | Pendientes {pending} | Fallidos {failed}",
  "bulk.aiParallelReviewTitle": "Revisar documentos",
  "bulk.aiParallelReviewStats": "Listos {ready} · Por revisar {review} · Guardados {saved} · Pendientes {pending} · Fallidos {failed} · Cancelados {cancelled}",
  "bulk.back": "Volver",
  "bulk.saveAll": "Guardar todos",
  "bulk.statusSaved": "Guardado",
  "bulk.statusReady": "Listo",
  "bulk.statusProcessing": "Procesando",
  "bulk.statusQueued": "En cola",
  "bulk.statusFailed": "Fallido",
  "bulk.statusNeedsReview": "Revisión",
  "bulk.statusOutOfQuota": "Límite agotado",
  "bulk.statusProcessingEllipsis": "Procesando...",
  "bulk.statusQueuedEllipsis": "En cola...",
  "bulk.loadingResults": "Cargando resultados...",
  "bulk.outOfQuotaTitle": "Cuota de extracciones agotada",
  "bulk.outOfQuotaMessage": "No quedan llamadas disponibles en tu plan ni en tu saldo extra. Puedes comprar 100 créditos por 10 € o consultar la renovación de tu plan.",
  "bulk.outOfQuotaButton": "Comprar créditos o ver planes",
  "bulk.batchLimitTitle": "Solo 1 documento por vez",
  "bulk.batchLimitMessage": "Hasta {count} documentos por operación. Divide los archivos en varios lotes.",
  "bulk.docProcessFailed": "No se pudo procesar este documento.",
  "bulk.optimizingHint": "Optimizando ruta y direcciones...",
  "bulk.locationsRouteLabel": "Ubicaciones / Ruta ({count})",
  "bulk.originLabel": "Origen",
  "bulk.destinationLabel": "Destino",
  "bulk.notSet": "No definido",
  "bulk.producerLabel": "Productora",
  "bulk.errorProcessOneDoc": "No se pudo procesar un documento",
  "bulk.errorSaveTrip": "No se pudo guardar el viaje",
  "bulk.toastReusedDocs": "Se reutilizaron {count} documento(s) ya subido(s)",
  "bulk.toastAlreadySavedDocs": "Ya hay {count} documento(s) guardado(s). No se duplicarán.",
  "bulk.toastSavedTrips": "Guardados {count} viajes",
  "bulk.purposeDefault": "Rodaje",
  "bulk.purposeWithProducer": "Rodaje: {producer}",
  "bulk.originalDocumentName": "Documento original",
  "bulk.aiProcess": "Procesar con IA",
  "bulk.examplePlaceholder": "Ejemplo:\nfecha,projectName,reason,origin,stop1,destination,km\n20-09-2025,Mi Proyecto,Rodaje,\"Plaza Mayor 1, 28012 Madrid\",\"Puerta del Sol 1, 28013 Madrid\",\"Plaza de Cibeles 1, 28014 Madrid\",2.5",
  "bulk.errorNoValidTrips": "No se encontraron viajes válidos para importar",
  "bulk.toastImportedTrips": "Importados {count} viajes",
  "bulk.toastFailedTrips": "Fallaron {count} viajes",
  "bulk.toastCsvLoaded": "CSV cargado",
  "bulk.errorCsvRead": "No se pudo leer el CSV",
  "bulk.errorLoginDrive": "Inicia sesión para importar desde Drive",
  "bulk.promptDriveLink": "Pega el enlace de Google Drive o el fileId del CSV",
  "bulk.errorDetectFileId": "No se pudo detectar el fileId",
  "bulk.errorDriveDownload": "Falló la descarga desde Drive",
  "bulk.toastCsvImportedDrive": "CSV importado desde Drive",
  "bulk.errorMaxDocuments": "Máximo 20 documentos por vez",
  "bulk.errorOnlyPdf": "Selecciona PDF, imágenes, Excel, CSV, TSV, TXT o DOCX.",
  "bulk.errorNotAuthenticated": "No estás autenticado",
  "bulk.errorUploadNone": "No se pudo subir ningún documento",
  "bulk.toastUploadedDocs": "Se subieron {count} documentos",
  "bulk.toastFailedDocs": "Fallaron {count} documentos",
  "bulk.errorUploadDoc": "Error al subir documento",
  "bulk.noLocationsFound": "No se encontraron ubicaciones.",
  "bulk.saveTrip": "Guardar viaje",

  // Plan limits
  "limits.maxTripsReached": "Has alcanzado el límite de viajes activos. Elimina algunos viajes o mejora tu plan.",
  "limits.maxAITripsReached": "Has alcanzado el límite de viajes creados con IA. Elimina algunos o mejora tu plan.",
  "limits.maxNonAITripsReached": "Has alcanzado el límite de viajes manuales. Elimina algunos o mejora tu plan.",
  "limits.maxProjectsReached": "Has alcanzado el límite de proyectos activos. Archiva algunos o mejora tu plan.",
  "limits.maxStopsReached": "Has alcanzado el límite de paradas por viaje ({limit} máximo).",
  "limits.csvImportExceedsLimit": "El CSV contiene más viajes de los que puedes importar. Máximo: {limit}",
  "limits.calendarImportExceedsLimit": "El calendario contiene más eventos de los que puedes importar. Máximo: {limit}",
  "limits.driveImportExceedsLimit": "Drive contiene más archivos de los que puedes importar. Máximo: {limit}",
  "limits.tripLimitWarning": "Viajes: {current}/{limit}",
  "limits.projectLimitWarning": "Proyectos: {current}/{limit}",
  "limits.aiLimitWarning": "Extracciones IA: {current}/{limit}",
  "limits.upgradePlan": "Mejorar plan",
  "limits.planBasic": "Plan Basic",
  "limits.planPro": "Plan Pro",
  "limits.maxTemplatesReached": "Has alcanzado el límite de plantillas de ruta. Elimina algunas o mejora tu plan.",
  "limits.maxReportsPerMonthReached": "Has alcanzado el límite de 1 informe por mes del plan Basic. Mejora a Pro para informes ilimitados.",
  "plans.features.trips200": "200 viajes activos",
  "tripDetail.title": "Detalles del viaje",
  "tripDetail.date": "Fecha",
  "tripDetail.project": "Proyecto",
  "tripDetail.driver": "Conductor",
  "tripDetail.currentUser": "Usuario actual",
  "tripDetail.purpose": "Productora o cliente",
  "tripDetail.route": "Ruta",
  "tripDetail.totalDistance": "Distancia total",
  "tripDetail.costBreakdown": "Desglose de costes",
  "tripDetail.customRate": "Tarifa personalizada",
  "tripDetail.invoicesTitle": "Facturas de combustible y mantenimiento",
  "tripDetail.attach": "Adjuntar",
  "tripDetail.attachInvoice": "Adjuntar factura",
  "tripDetail.invoiceAttachedTitle": "Factura adjuntada",
  "tripDetail.invoiceAttachedBody": "La extracción con IA empezará automáticamente.",
  "tripDetail.onlyOneInvoice": "Adjunta solo 1 factura por vez.",
  "tripDetail.missingProjectIdForInvoice": "Este viaje no tiene proyecto asociado. Vincúlalo a un proyecto para que la factura aparezca en Proyectos.",
  "tripDetail.invoiceExtracting": "Extrayendo con IA…",
  "tripDetail.invoiceCancelled": "Extracción cancelada",
  "tripDetail.totalDocumentedEmpty": "—",
  "tripDetail.invoiceStatusLabel": "Estado",
  "tripDetail.totalDocumented": "Total documentado: {amount}",
  "tripDetail.mapSetupTitle": "Configura Google Maps",
  "tripDetail.mapSetupBody": "Para ver el mapa, configura Google Maps en las variables de entorno.",
  "tripDetail.saveToken": "Guardar",
  "tripDetail.mapNotConfiguredTitle": "Mapa no configurado",
  "tripDetail.mapNotConfiguredBody": "Falta la variable VITE_GOOGLE_MAPS_BROWSER_KEY (y en producción GOOGLE_MAPS_SERVER_KEY en Vercel).",
  "tripDetail.mapLoadErrorTitle": "No se pudo cargar el mapa",
  "tripDetail.mapLoadError": "No se pudo cargar la ruta. Revisa la configuración de Google Maps.",
  "tripDetail.mapNoRoute": "No se encontró una ruta para este viaje.",
  "tripDetail.mapLoading": "Cargando mapa…",
  "tripDetail.noDocuments": "No hay documentos adjuntos",
  "tripDetail.attachDocument": "Adjuntar documento",
  "tripDetail.tabMap": "Mapa",
  "tripDetail.tabDocument": "Documento",
  "tripDetail.errorTitle": "Error",
  "tripDetail.authRequired": "No estás autenticado",
  "tripDetail.attachSaveFailed": "No se pudieron guardar los adjuntos",
  "tripDetail.attachSavedBody": "Se adjuntaron {count} archivo(s).",
  "tripDetail.attachFailed": "No se pudo adjuntar el archivo",
  "tripDetail.previewLoadFailed": "No se pudo cargar la vista previa.",
  "tripDetail.previewFrameTitle": "Vista previa",
  "tripDetail.previewUnavailable": "Vista previa no disponible en el navegador.",
  "tripDetail.backToDocuments": "Documentos",
  "tripDetail.openInNewTab": "Abrir en pestaña nueva",
  "tripDetail.downloadFile": "Descargar archivo",
  "tripDetail.driveFetchFailed": "No se pudo descargar desde Drive.",

  "projectDetail.totalKm": "Kilómetros totales",
  "projectDetail.shootingDays": "Días de rodaje",
  "projectDetail.kmPerDay": "Km por día de rodaje",
  "projectDetail.co2Estimated": "Emisiones CO₂ (est.)",
  "projectDetail.callSheetsTitle": "Hojas de llamada del proyecto",
  "projectDetail.uploadCallSheets": "Subir hojas de llamada (hasta 20)",
  "projectDetail.noCallSheets": "Aún no hay hojas de llamada subidas para este proyecto.",
  "projectDetail.invoicesTitle": "Facturas del proyecto",
  "projectDetail.attachInvoice": "Adjuntar factura",
  "projectDetail.confirmDeleteInvoice": "¿Eliminar esta factura? Se borrará también el resultado de la IA.",
  "projectDetail.toastProjectMismatch": "El proyecto extraído por IA no coincide, pero se creará el viaje igualmente. Revisa el resultado.",
  "projectDetail.toastMissingDate": "No se pudo extraer la fecha. Revisa manualmente.",
  "projectDetail.toastMissingLocations": "No se pudieron extraer ubicaciones. Revisa manualmente.",
  "projectDetail.toastTripCreatedFromAi": "Viaje creado desde IA del proyecto",
  "projectDetail.toastTripCreatedFromAiFailed": "No se pudo guardar el viaje creado por IA",
  "projectDetail.toastTripsCreatedFromAi": "Se guardaron {count} viaje(s) desde IA.",
  "projectDetail.toastTripsCreatedFromAiFailed": "No se pudieron guardar {count} viaje(s) desde IA.",
  "projectDetail.toastTripsCreatedFromAiPartial": "Se guardaron {saved} y fallaron {failed}.",
  "projectDetail.toastTripCreatedFromAiError": "Error creando viaje desde extracción: {message}",
  "projectDetail.toastDocumentUploaded": "Documento subido.",
  "projectDetail.toastOpenPdfError": "Error al abrir PDF: {message}",
  "projectDetail.toastStoragePathMissing": "Ruta del archivo no disponible.",
  "projectDetail.toastCallsheetDeleted": "Hoja de llamada eliminada",
  "projectDetail.toastDeleteError": "Error al eliminar: {message}",
  "projectDetail.toastReprocessingStarted": "Re-procesamiento iniciado",
  "projectDetail.toastExtractionStarted": "Extracción iniciada. El proceso comenzará en breve.",
  "projectDetail.toastExtractionStartedShort": "Extracción iniciada",
  "projectDetail.toastProcessingCancelled": "Procesamiento cancelado al cerrar el proyecto.",
  "projectDetail.toastExtractionStartError": "Error al iniciar extracción: {message}",
  "projectDetail.toastInvalidSession": "Sesión no válida",
  "projectDetail.toastWorkerExecuted": "Worker ejecutado: {count} trabajos procesados",
  "projectDetail.toastWorkerError": "Error al ejecutar worker: {message}",
  "projectDetail.toastOpenDocumentError": "Error al abrir documento: {message}",
  "projectDetail.toastInvoiceNoJob": "Esta factura no tiene un job de extracción asociado",
  "projectDetail.toastInvoiceDeleted": "Factura eliminada",
  "projectDetail.toastInvoiceLinkedToTrip": "Esta factura pertenece a un viaje. Elimínala desde el viaje asociado.",
  "projectDetail.noInvoices": "Aún no hay facturas subidas para este proyecto.",
  "projectDetail.discardAll": "Descartar todos",
  "projectDetail.saving": "Guardando...",
  "projectDetail.saveTrips": "Guardar {count} viajes",
  "trips.toastTripSaveFailedTitle": "No se pudo guardar el viaje",
  "trips.toastTripSaveFailedBody": "El cambio no llegó a la base de datos. Revisa la conexión o vuelve a iniciar sesión e inténtalo de nuevo.",
  "projectDetail.review": "Revisar",
  "projectDetail.cancelled": "Cancelado",
  "projectDetail.failed": "Error",
  "projectDetail.cancelProcessing": "Cancelar procesamiento",
  "projectDetail.tripLabel": "Viaje",
  "projectDetail.outOfQuota": "Límite agotado",
  "projectDetail.reprocess": "Volver a procesar",
  "projectDetail.reprocessWithAi": "Volver a procesar con IA",
  "projectDetail.extractDataWithAi": "Extraer datos con IA",
  "projectDetail.processing": "Procesando...",
  "projectDetail.processNow": "Procesar ahora",
  "projectDetail.toastDuplicateTripSkipped": "Ya existe un viaje con la misma fecha y ruta; no se creó un duplicado.",
  "bulk.duplicateTripConfirm": "Ya existe un viaje con la misma fecha y ruta. ¿Guardar de todas formas?",
  "projectDetail.toastAlreadyProcessing": "Este documento ya se está procesando; el estado se actualizará al terminar. Si se queda atascado, vuelve a intentarlo en un par de minutos.",

  // Project expenses
  "projectExpenses.title": "Gastos del proyecto",
  "projectExpenses.description": "Facturas que no están asociadas a un viaje específico. Escanea o sube recibos con cámara o arrastrando archivos.",
  "projectExpenses.total": "Total",
  "projectExpenses.saveError": "Error al guardar gasto",
  "expenses.receipt": "recibo",
  "expenses.receipts": "recibos",

  "vehicleConfig.title": "Parámetros de vehículo y costes",
  "vehicleConfig.subtitle": "Configura tu vehículo para estimar costes sin facturas.",
  "vehicleConfig.vehicleType": "Tipo de vehículo",
  "vehicleConfig.fuelConsumption": "Consumo de combustible",
  "vehicleConfig.fuelPrice": "Precio del combustible",
  "vehicleConfig.evConsumption": "Consumo (kWh/100km)",
  "vehicleConfig.energyPrice": "Precio de la energía (€/kWh)",
  "vehicleConfig.maintenancePerKm": "Mantenimiento (€/km)",
  "vehicleConfig.otherPerKm": "Otros (€/km)",
  "vehicleConfig.estimatedFuelPerKm": "Energía estimada (€/km)",
  "vehicleConfig.typeUnknown": "No especificado",
  "vehicleConfig.typeGasoline": "Gasolina",
  "vehicleConfig.typeDiesel": "Diésel",
  "vehicleConfig.typeEv": "Eléctrico",
  "vehicleConfig.cancel": "Cancelar",
  "vehicleConfig.save": "Guardar",
  "vehicleConfig.saving": "Guardando…",
  "vehicleConfig.toastSaving": "Guardando configuración…",
  "vehicleConfig.toastSaved": "Configuración guardada",
  "vehicleConfig.invalidNumber": "Número no válido",

  "reports.verifyTitle": "Generar informe fiscal",
  "reports.verifyChecklistTitle": "Lista de verificación pre-exportación",
  "reports.verifyChecklistBody": "El sistema ha revisado los viajes del período seleccionado en busca de posibles problemas.",
  "reports.verifyNoProblems": "No se encontraron problemas potenciales. Listo para generar.",
  "reports.verifyFoundWarnings": "Se encontraron {count} advertencia(s)",
  "reports.verifyContinueOrReview": "Puedes continuar con la generación del informe o revisar los viajes antes.",
  "reports.back": "Atrás",
  "reports.generateReport": "Generar informe",
  "reports.title": "Informes",
  "reports.subtitle": "Genera y gestiona informes de kilometraje",
  "reports.generateNew": "Generar nuevo informe",
  "reports.project": "Proyecto",
  "reports.selectProject": "Selecciona proyecto",
  "reports.allProjects": "Todos los proyectos",
  "reports.month": "Mes",
  "reports.year": "Año",
  "reports.from": "Desde",
  "reports.to": "Hasta",
  "reports.toastInvalidRangeTitle": "Rango de fechas inválido",
  "reports.toastInvalidRangeBody": "La fecha 'Desde' no puede ser posterior a 'Hasta'.",
  "reports.tableGeneratedAt": "Generado el",
  "reports.tablePeriod": "Período del informe",
  "reports.tableActions": "Acciones",
  "reports.view": "Ver",
  "reports.warningImprobableDistance": "Distancia improbable",
  "reports.warningZeroDistance": "Distancia 0 (o inválida)",
  "reports.warningMissingPurpose": "Falta el motivo del viaje",
  "reports.toastGeneratedTitle": "Informe generado",
  "reports.toastGeneratedBody": "El informe fiscal se ha generado correctamente.",

  "reportView.filePrefix": "reporte",
  "reportView.sheetName": "Informe",
  "reportView.toastExportingTitle": "Exportando a {format}",
  "reportView.toastExportingBody": "El archivo se descargará en breve.",
  "reportView.toastPdfDownloadedTitle": "PDF descargado",
  "reportView.toastPdfDownloadedBody": "El archivo se ha descargado correctamente.",
  "reportView.toastExportErrorTitle": "Error al exportar",
  "reportView.toastExportErrorBody": "No se pudo generar el archivo. Inténtalo de nuevo.",
  "reportView.backToReports": "Volver a informes",
  "reportView.backShort": "Volver",
  "reportView.export": "Exportar",
  "reportView.exportExcel": "Excel (.xlsx)",
  "reportView.exportPdf": "PDF",
  "reportView.exportCsv": "CSV",
  "reportView.exportZip": "Descargar ZIP con documentación",
  "reportView.exportZipPreparing": "Preparando documentos...",
  "reportView.exportZipDone": "ZIP descargado",
  "reportView.exportZipEmpty": "No hay documentos asociados a este informe",
  "reportView.exportZipError": "Error al generar el ZIP",
  "reportView.exportZipProOnly": "Solo disponible en plan Pro",
  "reportView.print": "Imprimir",
  "reportView.saveReport": "Guardar",
  "reportView.toastSaveErrorTitle": "No se pudo guardar el informe",
  "reportView.toastSaveErrorBody": "El informe sigue abierto. Comprueba la conexión y vuelve a intentar guardarlo.",
  "reportView.toastSavedTitle": "Informe guardado",
  "reportView.toastSavedBody": "El informe se ha guardado en la lista.",
  "reportView.notFoundTitle": "Informe no encontrado",
  "reportView.notFoundBody": "Este informe no existe o se ha eliminado.",
  "reportView.reportTitle": "Registro de viajes",
  "reportView.periodLabel": "Período",
  "reportView.driverLabel": "Conductor",
  "reportView.addressLabel": "Dirección",
  "reportView.licensePlateLabel": "Matrícula(s)",
  "reportView.projectLabel": "Proyecto",
  "reportView.ratePerKmLabel": "Tarifa por km",
  "reportView.passengerSurchargeLabel": "Tarifa por pasajero",
  "reportView.mergePassengers": "Unir suplemento de pasajeros al kilometraje",
  "reportView.colReimbursement": "Reembolso",
  "reportView.totalReimbursementLabel": "Total reembolso",
  "reportView.colDate": "Fecha",
  "reportView.colProject": "Proyecto",
  "reportView.colCompanyProducer": "Empresa/Productor",
  "reportView.colRoute": "Ruta",
  "reportView.colPassengers": "Pasajeros",
  "reportView.colPassengersShort": "Pas.",
  "reportView.colDistance": "Distancia",
  "reportView.colDistanceKm": "Distancia (km)",
  "reportView.totalDistanceLabel": "Total de kilómetros recorridos",
  "reportView.totalShort": "Total",
  "reportView.pdfLanguage": "Idioma del PDF",

  "dashboard.actionUploadCallsheet": "Subir callsheet",
  "dashboard.actionAddTrip": "Añadir viaje",
  "dashboard.kpiBillableMonth": "€ a facturar (mes)",
  "dashboard.kpiKmMonth": "Kilómetros (mes)",
  "dashboard.kpiTripsMonth": "Viajes (mes)",
  "dashboard.kpiCo2Month": "CO₂ (mes)",
  "dashboard.vsPrevMonth": "vs. mes anterior",
  "dashboard.treePerYearShort": "Absorción anual de aproximadamente {trees} árbol maduro",
  "dashboard.treesPerYearShort": "Absorción anual de aproximadamente {trees} árboles maduros",
  "dashboard.attentionUnavailable": "No se pudieron actualizar los avisos. Vuelve a intentarlo.",
  "dashboard.attentionTitle": "Necesita tu atención",
  "dashboard.attentionEmpty": "Todo en orden",
  "dashboard.attentionCallsheetFailed": "Callsheet fallida",
  "dashboard.attentionCallsheetReview": "Callsheet pendiente de revisión",
  "dashboard.attentionMore": "+{count} más en Viajes",
  "dashboard.aiCounterTitle": "Callsheets IA",
  "dashboard.aiCounterRenews": "Se renueva el 1 de {month}",
  "dashboard.aiCounterExhausted": "Límite mensual agotado",
  "dashboard.aiCounterNearLimit": "Te queda poco este mes",
  "dashboard.reportReadyTitle": "Informe de {month} listo",
  "dashboard.reportReadyCta": "Generar PDF",
  "dashboard.carMarginTitle": "Margen neto de tu coche",
  "dashboard.carMarginMonth": "Tu coche te dejó ~{amount} netos este mes",
  "dashboard.carMarginDetail": "Facturado {billed} · coste estimado {cost}",
  "dashboard.carMarginPerKmDetail": "{rate} de Kilometergeld − {cost} de coste real por km",
  "dashboard.aiChipLabel": "callsheets IA",
  "dashboard.aiChipAnnual": "callsheets IA/año",
  "dashboard.aiChipMonthly": "callsheets IA/mes",
  "dashboard.reportReadyDesc": "{count} viajes registrados. Genera el PDF y envíalo a producción.",
  "dashboard.carMarginMissing": "Añade consumo, precio de combustible y costes por km en Ajustes para calcularlo.",
  "dashboard.proUsageTitle": "% de uso profesional",
  "dashboard.proUsageDetail": "{workKm} km profesionales de {totalKm} km totales ({year})",
  "dashboard.proUsageMissing": "Introduce los km totales anuales de tu coche en Ajustes (de la factura del taller o la ITV).",
  "dashboard.monthlyBarsTitle": "Km y € por mes",
  "settings.annualCarTotalKm": "Km totales del coche este año",
  "settings.annualCarTotalKmHint": "Lectura del cuentakilómetros o factura del taller/ITV; se usa para el % de uso profesional.",
  "settings.carCostsTitle": "Costes del coche",
  "settings.carCostsHint": "Se usan para la tarjeta \"Margen neto de tu coche\" del dashboard.",
  "settings.fuelPricePerLiter": "Precio del combustible (€/L)",
  "settings.electricityPricePerKwh": "Precio de la electricidad (€/kWh)",
  "settings.maintenanceEurPerKm": "Mantenimiento (€/km)",
  "settings.otherEurPerKm": "Otros costes (€/km)",
  "bulk.aiQuotaLine": "Callsheets IA este mes: {used}/{limit}",
  "bulk.aiQuotaAnnualLine": "Callsheets IA este año de suscripción: {used}/{limit}",

  "reportPdf.title": "Liquidación de kilometraje",
  "reportPdf.colPurpose": "Propósito",
  "reportPdf.colRate": "€/km",
  "reportPdf.colAmount": "Importe",
  "reportPdf.tripsLabel": "Viajes",
  "reportPdf.totalKmLabel": "Kilómetros totales",
  "reportPdf.travelCosts": "Kilometraje (Kilometergeld)",
  "reportPdf.expensesTitle": "Gastos",
  "reportPdf.expenseToll": "Peaje",
  "reportPdf.expenseParking": "Parking",
  "reportPdf.expenseFuel": "Combustible",
  "reportPdf.expenseOther": "Otros",
  "reportPdf.receiptsAnnex": "Recibos anexos (exportación ZIP).",
  "reportPdf.grandTotal": "Total a facturar",
  "reportPdf.inclPassengerSurcharge": "incl. suplemento por pasajeros",
  "reportPdf.inclExpenses": "incl. gastos",
  "reportPdf.totalBoxLabel": "Total",
  "reportPdf.shootDayOne": "1 día de rodaje",
  "reportPdf.shootDays": "{count} días de rodaje",
  "reportPdf.co2Line": "Emisiones de CO2: {kg} kg — equivalen a la absorción anual de ~{trees} árboles.",
  "reportPdf.co2Only": "Emisiones de CO2: {kg} kg.",
  "reportPdf.colCo2": "CO2 (kg)",
  "reportPdf.totalCo2Label": "CO2 total",
  "dashboard.setupTitle": "Completa tu perfil para que todo se calcule solo",
  "dashboard.setupBothMissing": "Falta tu tarifa por km y tu dirección base: sin ellas no podemos calcular distancias ni importes.",
  "dashboard.setupRateMissing": "Falta tu tarifa por km: sin ella no podemos calcular los importes de tus viajes.",
  "dashboard.setupBaseMissing": "Falta tu dirección base: con ella el origen y la distancia se rellenan solos al crear un viaje.",
  "dashboard.setupCta": "Completar en Ajustes",
  "reportView.tripsCount": "{count} viajes",
  "reportView.tripsCountOne": "1 viaje",
  "reportView.contentMenu": "Contenido del informe",
  "reportView.optCo2": "Columna de CO2",
  "reportView.optTrees": "Árboles equivalentes",
  "reportView.optSource": "Fuente de los factores",
  "reportView.optSignature": "Bloque de firma",
  "reportPdf.co2Source": "Fuente: Umweltbundesamt/JEC (tanque-a-rueda); electricidad: Ember/OWID {year}; ~{treeKg} kg CO2 por árbol y año.",
  "reportPdf.signature": "Fecha y firma",
  "reportPdf.footer": "Creado con Fahrtenbuch Pro · fahrtenbuchpro.com",
  "reportPdf.pageOf": "Página {page} de {pages}",

  "advancedRoutes.createTemplateTitle": "Crear nueva plantilla",
  "advancedRoutes.saveAsTemplate": "Guardar como plantilla",
  "advancedRoutes.createTemplateDesc": "Guarda esta ruta para usarla en futuros viajes.",
  "advancedRoutes.save": "Guardar",
  "advancedRoutes.editTemplateTitle": "Editar plantilla",
  "advancedRoutes.basicInfo": "Información básica",
  "advancedRoutes.templateName": "Nombre de plantilla",
  "advancedRoutes.category": "Categoría",
  "advancedRoutes.categoryBusiness": "Negocios",
  "advancedRoutes.categoryCommute": "Conmutación",
  "advancedRoutes.categoryClient": "Cliente",
  "advancedRoutes.categoryOther": "Otro",
  "advancedRoutes.routeDetails": "Detalles de ruta",
  "advancedRoutes.startLocation": "Ubicación de inicio",
  "advancedRoutes.endLocation": "Ubicación de destino",
  "advancedRoutes.distanceKm": "Distancia (km)",
  "advancedRoutes.estimatedTimeMin": "Tiempo estimado (min)",
  "advancedRoutes.additionalDetails": "Detalles adicionales",
  "advancedRoutes.description": "Descripción",
  "advancedRoutes.descriptionPlaceholder": "Ingresa una descripción",
  "advancedRoutes.cancel": "Cancelar",
  "advancedRoutes.createTemplate": "Crear plantilla",
  "advancedRoutes.saveChanges": "Guardar cambios",
  "advancedRoutes.pageTitle": "Plantillas de rutas",
  "advancedRoutes.pageSubtitle": "Guarda rutas frecuentes como plantillas reutilizables.",
  "advancedRoutes.statTotalTemplates": "Total de plantillas",
  "advancedRoutes.statAvgDistance": "Distancia promedio",
  "advancedRoutes.statMostUsed": "Más usada",
  "advancedRoutes.none": "Ninguna",
  "advancedRoutes.categoryAll": "Todas las categorías",
  "advancedRoutes.toastLoadError": "No se pudieron cargar las plantillas",
  "advancedRoutes.toastLoginRequired": "Inicia sesión para guardar plantillas",
  "advancedRoutes.toastNameRequired": "Pon un nombre a la plantilla",
  "advancedRoutes.errorUpdateFailed": "No se pudo actualizar la plantilla",
  "advancedRoutes.errorCreateFailed": "No se pudo crear la plantilla",
  "advancedRoutes.toastUpdated": "Plantilla actualizada",
  "advancedRoutes.toastCreated": "Plantilla creada",
  "advancedRoutes.edit": "Editar",
  "advancedRoutes.use": "Usar",
  "advancedRoutes.loading": "Cargando…",
  "advancedRoutes.noTemplatesInCategory": "No hay plantillas en esta categoría. Crea tu primera plantilla para empezar.",
  "advancedRoutes.toastSaveFailed": "No se pudo guardar la plantilla",
  "advancedRoutes.toastUsesUpdateFailed": "No se pudo actualizar el contador",

  "advancedCosts.pageTitle": "Análisis de costes",
  "advancedCosts.pageSubtitle": "Análisis de costes de tus viajes basado en facturas y gastos registrados.",
  "advancedCosts.uploadInvoice": "Subir factura",
  "advancedCosts.uploadShort": "Subir",
  "advancedCosts.periodAllTime": "Todo el tiempo",
  "advancedCosts.periodLastMonth": "Último mes",
  "advancedCosts.periodLast3Months": "Últimos 3 meses",
  "advancedCosts.periodLast6Months": "Últimos 6 meses",
  "advancedCosts.periodLastYear": "Último año",
  "advancedCosts.tabSummary": "Resumen",
  "advancedCosts.tabMonthly": "Costes mensuales",
  "advancedCosts.monthlyChartTitle": "Evolución mensual",
  "advancedCosts.statTotalDistance": "Distancia total",
  "advancedCosts.statTotalTrips": "Viajes totales",
  "advancedCosts.statEstimatedTotalCost": "Coste total estimado",
  "advancedCosts.statAvgCostPerKm": "Coste prom. / km",
  "advancedCosts.breakdownTitle": "Desglose de costes básico",
  "advancedCosts.breakdownFuelEnergy": "Combustible / Energía",
  "advancedCosts.breakdownTolls": "Peajes",
  "advancedCosts.breakdownParking": "Parking",
  "advancedCosts.breakdownOther": "Otros",
  "advancedCosts.breakdownAvgPerTrip": "Coste prom. / viaje",
  "advancedCosts.assumptionsTitle": "Resumen de costes",
  "advancedCosts.assumptionFuelPerKm": "Combustible: {amount}/km",
  "advancedCosts.assumptionTollsTotal": "Peajes (total): {amount}",
  "advancedCosts.assumptionParkingTotal": "Parking (total): {amount}",
  "advancedCosts.assumptionOtherTotal": "Otros (total): {amount}",
  "advancedCosts.assumptionsHint": "Estos costes se derivan de tu configuración de vehículo en el perfil y los gastos registrados en tus viajes.",
  "advancedCosts.warningNoVehicleConfig": "Configuración de vehículo incompleta",
  "advancedCosts.warningNoVehicleConfigDetails": "No has configurado completa la información de tu vehículo en tu perfil. Los costes de combustible/energía no se pueden calcular sin estos datos.",
  "advancedCosts.assumptionsEdit": "Haz clic aquí para editar.",
  "advancedCosts.projectAnalysisTitle": "Análisis de costes por proyecto",
  "advancedCosts.projectLabel": "Proyecto:",
  "advancedCosts.allProjects": "Todos los proyectos",
  "advancedCosts.tableProject": "Proyecto",
  "advancedCosts.tableDistanceAbbr": "Dist.",
  "advancedCosts.tableTrips": "Viajes",
  "advancedCosts.tableTotal": "Total",
  "advancedCosts.tableEurPerKm": "€/km",
  "advancedCosts.monthlySummaryTitle": "Resumen mensual",
  "advancedCosts.tableMonth": "Mes",
  "advancedCosts.tableDistance": "Distancia",
  "advancedCosts.tableFuelEnergy": "Combustible / Energía",
  "advancedCosts.tableTolls": "Peajes",
  "advancedCosts.tableParking": "Parking",
  "advancedCosts.tableOther": "Otros",
  "advancedCosts.toastSelectProject": "Selecciona un proyecto para adjuntar la factura",
  "advancedCosts.toastSupabaseNotConfigured": "Supabase no está configurado",
  "advancedCosts.toastMaxDocuments": "Máximo 20 documentos por vez",
  "advancedCosts.toastOnlyPdfOrImages": "Solo se permiten archivos PDF o imágenes",
  "advancedCosts.toastNotAuthenticated": "No estás autenticado",
  "advancedCosts.toastUploadedInvoices": "Se subieron {count} factura(s)/documento(s). La extracción con IA empezará automáticamente.",
  "advancedCosts.toastFailedDocuments": "Fallaron {count} documento(s)",
  "advancedCosts.errorUploadInvoice": "Error al subir factura",
  "advancedCosts.chartNoData": "No hay datos para mostrar.",
  "advancedCosts.chartNoCostsTitle": "Aún no hay costes con importe para este periodo.",
  "advancedCosts.chartNoCostsBody": "Configura el vehículo o sube facturas con importe (o ejecuta la extracción) para ver los gráficos.",
  "advancedCosts.chartSeriesTotal": "Total",
  "advancedCosts.pageSubtitleNew": "Analiza la rentabilidad real de tus viajes comparando costes vs reembolsos.",
  "advancedCosts.periodThisMonth": "Este mes",
  "advancedCosts.periodLastQuarter": "Último trimestre",
  "advancedCosts.periodThisYear": "Este año",
  "advancedCosts.reimbursement": "Reembolso",
  "advancedCosts.realCost": "Coste real",
  "advancedCosts.balance": "Balance",
  "advancedCosts.profitable": "Rentable",
  "advancedCosts.notProfitable": "No rentable",
  "advancedCosts.tripsLabel": "viajes",
  "advancedCosts.trip": "viaje",
  "advancedCosts.costBreakdown": "Desglose del coste",
  "advancedCosts.projectBreakdown": "Rentabilidad por proyecto",
  "advancedCosts.noProjectsInPeriod": "No hay proyectos con viajes en este periodo.",
  "advancedCosts.tableCost": "Coste",
  "advancedCosts.tableReimbursement": "Reembolso",
  "advancedCosts.total": "Total",
  "advancedCosts.infoFooter": "Los costes se calculan según tu configuración de vehículo y los gastos registrados en cada viaje.",
  "advancedCosts.loadMoreProjects": "Cargar más proyectos",
  "advancedCosts.loadMoreTrips": "Cargar más viajes",
  "advancedCosts.remaining": "restantes",

  "advancedEmissions.configTitle": "Configuración de análisis CO₂",
  "advancedEmissions.configSubtitle": "Configura las preferencias de análisis de emisiones CO₂",
  "advancedEmissions.pageTitle": "Ranking CO₂",
  "advancedEmissions.pageSubtitle": "Evalúa el impacto ambiental de tus viajes y compáralos.",
  "advancedEmissions.austriaNotice": "Los factores de emisión de CO₂ utilizados (Climatiq UBA Austria 2022, 0,2472 kg CO₂e/km) corresponden a Austria. Si tu país es diferente, los valores mostrados son una aproximación basada en datos austriacos.",
  "advancedEmissions.export": "Exportar",
  "advancedEmissions.welcomeTitle": "Bienvenido al análisis de CO₂",
  "advancedEmissions.welcomeBody": "Obtén información sobre el impacto ambiental de tus viajes. Configura tus preferencias de análisis para comenzar a rastrear tu huella de carbono y descubrir oportunidades para viajes más sostenibles.",
  "advancedEmissions.configureButton": "Configurar análisis CO₂",
  "advancedEmissions.totalEmissions": "Emisiones totales de CO₂",
  "advancedEmissions.totalFootprintTitle": "Huella de carbono total",
  "advancedEmissions.totalFootprintUnit": "kg CO₂",
  "advancedEmissions.compensationTitle": "Equivalencia ilustrativa",
  "advancedEmissions.compensationBody": "Absorción aproximada durante un año:",
  "advancedEmissions.treeSingular": "árbol",
  "advancedEmissions.treePlural": "árboles",
  "advancedEmissions.breakdownTitle": "Desglose de Proyectos",
  "advancedEmissions.breakdownTitleTrips": "Desglose de viajes",
  "advancedEmissions.trendChartTitle": "Tendencia de Emisiones (kg CO₂)",
  "advancedEmissions.trendChartProjected": "Proyectado",
  "advancedEmissions.trendChartReal": "Real",
  "advancedEmissions.trendChartWeek": "Semana {week}",
  "advancedEmissions.trendChartNoData": "No hay datos para mostrar.",
  "advancedEmissions.co2TotalLabel": "CO₂ TOTAL",
  "advancedEmissions.co2PerPassengerLabel": "POR PASAJERO",
  "advancedEmissions.tripsLabel": "viajes",
  "advancedEmissions.avgEfficiency": "Eficiencia promedio",
  "advancedEmissions.fuelConsumption": "Consumo de combustible",
  "advancedEmissions.electricConsumption": "Consumo eléctrico",
  "advancedEmissions.treesNeeded": "Árboles necesarios",
  "advancedEmissions.resultsTitle": "Resultados del ranking CO₂ ({count})",
  "advancedEmissions.noResultsTitle": "No hay resultados para este periodo",
  "advancedEmissions.noResultsBody": "Cambia el rango de tiempo o añade viajes para ver el ranking.",
  "advancedEmissions.metricCo2Kg": "CO₂ (kg)",
  "advancedEmissions.metricEfficiency": "Eficiencia (kg/km)",
  "advancedEmissions.metricDistance": "Distancia (km)",
  "advancedEmissions.metricTrips": "Viajes",
  "advancedEmissions.viewMode": "Modo de vista",
  "advancedEmissions.viewModeProjectsOnly": "Solo proyectos",
  "advancedEmissions.viewModeAllTrips": "Todos los viajes",
  "advancedEmissions.sortBy": "Ordenar por",
  "advancedEmissions.sortByCo2": "CO₂ (kg)",
  "advancedEmissions.sortByEfficiency": "Eficiencia",
  "advancedEmissions.sortByDistance": "Distancia",
  "advancedEmissions.sortByHelp": "Selecciona la métrica principal para clasificar proyectos",
  "advancedEmissions.timeRange": "Rango de tiempo",
  "advancedEmissions.allTime": "Todo el tiempo",
  "advancedEmissions.last7Days": "Últimos 7 días",
  "advancedEmissions.last30Days": "Últimos 30 días",
  "advancedEmissions.last90Days": "Últimos 90 días",
  "advancedEmissions.last6Months": "Últimos 6 meses",
  "advancedEmissions.thisYear": "Este año",
  "advancedEmissions.selectPeriodHelp": "Selecciona el período de tiempo para el análisis de CO₂",
  "advancedEmissions.searchPlaceholder": "Buscar proyecto...",
  "advancedEmissions.resetFilters": "Restablecer",
  "advancedEmissions.noFilterResultsTitle": "Sin resultados",
  "advancedEmissions.noFilterResultsBody": "No hay resultados con los filtros actuales.",
  "advancedEmissions.filterByProjectPlaceholder": "Filtrar por proyecto...",
  "advancedEmissions.sortDirectionAsc": "Orden ascendente",
  "advancedEmissions.sortDirectionDesc": "Orden descendente",
  "advancedEmissions.fuelEfficiency": "Eficiencia de combustible (L/100km)",
  "advancedEmissions.fuelEfficiencyHelp": "Consumo promedio de combustible por 100km (usado para cálculos de CO₂)",
  "advancedEmissions.aboutTitle": "Acerca de los cálculos de CO₂",
  "advancedEmissions.aboutBody": "Las emisiones de CO₂ se calculan basándose en la eficiencia de combustible y el tipo de vehículo. El análisis te ayuda a entender el impacto ambiental de tus viajes e identificar oportunidades para viajes más eficientes.",
  "advancedEmissions.cancel": "Cancelar",
  "advancedEmissions.save": "Guardar configuración",
  "advancedEmissions.fallbackTripName": "Viaje",
  "advancedEmissions.fallbackProjectName": "Proyecto",
  "advancedEmissions.ratingVeryLow": "Muy baja",
  "advancedEmissions.ratingLow": "Baja",
  "advancedEmissions.ratingModerate": "Moderada",
  "advancedEmissions.ratingHigh": "Alta",
  "advancedEmissions.ratingVeryHigh": "Muy alta",
  "advancedEmissions.trendStable": "Estable",
  "advancedEmissions.trendNew": "Nuevo",
  "advancedEmissions.trendImproving": "Mejorando",
  "advancedEmissions.trendWorsening": "Empeorando",
  "advancedEmissions.allProjects": "Todos los proyectos",
  "validation.title": "Validación",
  "validation.excessive": "Consumo excesivo: {value} {unit}. El máximo permitido es {max} {unit}.",
  "validation.tooLow": "Consumo demasiado bajo: {value} {unit}. El mínimo realista es {min} {unit}.",

  "settings.title": "Ajustes",
  "settings.tabProfile": "Perfil",
  "settings.tabApis": "APIs y servicios externos",
  "settings.tabPersonalization": "Personalización",
  "settings.tabLanguage": "Idioma",
  "settings.tabNews": "Novedades",
  "settings.tabHelp": "Ayuda y docs",
  "settings.cancel": "Cancelar",
  "settings.save": "Guardar ajustes",
  "settings.refresh": "Actualizar",
  "settings.toastSaving": "Guardando ajustes…",
  "settings.toastSaved": "Ajustes guardados",
  "settings.sessionInvalid": "Sesión inválida.",
  "settings.deleteAccountFailed": "No se pudo eliminar la cuenta.",
  "settings.accountDeleted": "Cuenta eliminada.",
  "settings.googleConnectFailed": "No se pudo iniciar la conexión",
  "settings.googleDisconnectFailed": "No se pudo desconectar",
  "settings.profileSectionTitle": "Mi perfil",
  "settings.fullName": "Nombre completo",
  "settings.vatId": "NIF / VAT ID (UID)",
  "settings.licensePlate": "Matrícula",
  "settings.ratePerKm": "Tarifa (€/km)",
  "settings.passengerSurcharge": "Recargo por pasajero (€)",
  "settings.ratesSource": "Tarifa definida en Ajustes. Se aplica a todos los viajes y proyectos.",
  "settings.ratesDefaults": "Si dejas los campos vacíos, se aplican 0,50 €/km y 0,15 € por pasajero. Un cero se respeta.",
  "settings.baseAddress": "Dirección base / Domicilio",
  "settings.city": "Ciudad",
  "settings.country": "País",
  "settings.vehicleSectionTitle": "Vehículo y emisiones",
  "settings.vehicleSectionBody": "Configura el tipo de combustible y el consumo para calcular CO₂ de forma correcta.",
  "settings.fuelType": "Tipo de vehículo",
  "settings.fuelTypeUnknown": "No especificado",
  "settings.fuelTypeGasoline": "Gasolina",
  "settings.fuelTypeDiesel": "Diésel",
  "settings.fuelTypeEv": "Eléctrico",
  "settings.fuelConsumption": "Consumo (L/100km)",
  "settings.evConsumption": "Consumo (kWh/100km)",
  "settings.gridFactor": "Intensidad de la red (AT) (kg CO₂/kWh)",
  "settings.gridFactorHelp": "Media anual de la red eléctrica de tu país (AT/DE/CZ/HU), fuente Ember/Our World in Data. Se revisa una vez al año.",
  "settings.emissionsGridAnnualNote": "* Media anual de la generación eléctrica del país; actualización manual anual.",
  "settings.emissionsStaticFuelTitle": "Factor de combustible (tabla estática)",
  "settings.emissionsStaticGridTitle": "Red eléctrica (media anual)",
  "settings.emissionsDataSourceTitle": "Fuente de Datos de Emisiones",
  "settings.emissionsDataSourceBody": "Los cálculos de CO₂ usan factores estáticos con fuente citada; la precisión viene del consumo real de tu vehículo:",
  "settings.emissionsFactor": "Factor",
  "settings.emissionsSource": "Fuente",
  "settings.emissionsYear": "Año",
  "settings.emissionsRegion": "Región",
  "settings.emissionsActivityId": "Activity ID",
  "settings.emissionsWellToWheel": "* Metodología tanque-a-rueda: CO₂ emitido al quemar el combustible (no incluye refinado ni transporte).",
  "settings.emissionsIntensity": "Intensidad",
  "settings.emissionsZone": "Zona",
  "settings.emissionsUpdated": "Actualizado",
  "settings.deleteAccountTitle": "Eliminar cuenta",
  "settings.deleteAccountBody": "Se eliminarán definitivamente tus viajes, documentos, proyectos, informes y ajustes. Si tienes una suscripción, se cancelará para evitar renovaciones. El proceso puede tardar unos minutos. Si se interrumpe, vuelve a pulsar para continuar; los datos ya eliminados no se recuperan.",
  "settings.deletingAccount": "Eliminación en curso. Esperando a que terminen las operaciones pendientes y retirando los datos. Mantén esta ventana abierta.",
  "settings.deleteAccountIncomplete": "La eliminación no se ha completado. La cuenta queda en proceso de eliminación; vuelve a pulsar «Eliminar mi cuenta» para continuar. No podrás guardar nuevos cambios mientras tanto.",
  "settings.deleteAccountButton": "Eliminar mi cuenta",
  "settings.apisGeminiBody": "IA del servidor para analizar callsheets",
  "settings.apisInactive": "Inactivo",
  "settings.apisSavedSelection": "El estado de Gemini refleja la configuración guardada. Guarda los cambios para aplicarlos.",
  "ui.aiProviderUnavailable": "No se pudo usar el proveedor de IA seleccionado. Revisa la configuración guardada y tu plan. No se ha cambiado a otro proveedor.",
  "settings.apisActive": "Activo",
  "settings.apisOpenRouterTitle": "OpenRouter (Opcional)",
  "settings.apisOpenRouterBody": "Usa tu propia API key",
  "settings.apisApiKey": "API Key",
  "settings.apisGoogleCalendarBody": "Sincronizar eventos",
  "settings.apisConnect": "Conectar",
  "settings.appearanceTitle": "Ajustes de apariencia",
  "settings.theme": "Tema",
  "settings.current": "actual",
  "settings.themeLight": "Claro",
  "settings.themeLightDesc": "Fondos claros y efecto vidrio suave.",
  "settings.themeDark": "Oscuro",
  "settings.themeDarkDesc": "Mayor contraste para ambientes con poca luz.",
  "settings.themeHint": "Cambia entre claro y oscuro sin tocar el resto de estilos.",
  "settings.backgroundImage": "Imagen de fondo",
  "settings.uploadFromComputer": "Subir desde el ordenador",
  "settings.remove": "Quitar",
  "settings.none": "Ninguna",
  "settings.presetBackgrounds": "Fondos preestablecidos",
  "settings.uiOpacity": "Opacidad de la IU",
  "settings.uiBlur": "Efecto de desenfoque de la IU",
  "settings.backgroundBlur": "Desenfoque de imagen de fondo",
  "settings.appVersionTitle": "Versión de la aplicación",
  "settings.checkUpdates": "Buscar actualizaciones",
  "settings.changelogBody": "Ver cambios recientes y actualizaciones",
  "settings.viewChangelog": "Ver Changelog",
  "settings.helpTitle": "Ayuda y documentación",
  "settings.docsTitle": "Documentación",
  "settings.docsBody": "Aprende a usar todas las funciones",
  "settings.viewDocs": "Ver documentación",
  "settings.supportTitle": "Soporte",
  "settings.supportBody": "¿Necesitas ayuda? Contáctanos",
  "settings.contactSupport": "Contactar soporte",
  "settings.tourTitle": "Tutorial interactivo",
  "settings.tourBody": "Vuelve a ver la visita guiada por la app",
  "settings.tourStart": "Iniciar tutorial",
  "settings.build": "Build:",

  // Tutorial interactivo (OnboardingTour)
  "tour.stepOf": "Paso {current} de {total}",
  "tour.skip": "Saltar tutorial",
  "tour.back": "Anterior",
  "tour.next": "Siguiente",
  "tour.finish": "Terminar",
  "tour.welcomeTitle": "Te damos la bienvenida a Fahrtenbuch Pro",
  "tour.welcomeBody": "Te llevamos de visita guiada por la app: pasaremos por el panel, los viajes, los proyectos, los informes y el calendario. Un minuto y listo.",
  "tour.kpisTitle": "Tu mes de un vistazo",
  "tour.kpisBody": "€ a facturar, kilómetros, viajes y CO₂ del mes, comparados con el mes anterior. Cada tarjeta te lleva a su página.",
  "tour.attentionTitle": "Cuota de IA y avisos",
  "tour.attentionBody": "El contador muestra las extracciones de callsheets que llevas este mes. La campana reúne lo que necesita tu atención: callsheets por revisar y viajes con datos raros.",
  "tour.addTripTitle": "Añade viajes a mano",
  "tour.addTripBody": "Con \"Añadir viaje\": el origen parte de tu dirección base, la distancia se calcula sola con Google Maps, y puedes añadir hasta 25 paradas, pasajeros y gastos con recibo.",
  "tour.bulkTitle": "O deja que la IA los cree",
  "tour.bulkBody": "Con \"Carga masiva\" subes callsheets en PDF o foto y la IA extrae la fecha, el proyecto y las localizaciones de rodaje. Tú revisas y guardas.",
  "tour.tableTitle": "Tu tabla de viajes",
  "tour.tableBody": "Filtra por proyecto y año, selecciona varios para borrar en lote y usa el menú ⋮ de cada fila: ver mapa, añadir al calendario, editar o eliminar.",
  "tour.projectsTitle": "Proyectos",
  "tour.projectsBody": "Cada producción es una carpeta: agrupa sus viajes, callsheets y documentos, y hereda la productora y la tarifa.",
  "tour.reportsTitle": "Informes",
  "tour.reportsBody": "Aquí generas el informe de Kilometergeld: elige proyecto y período y expórtalo en PDF (alemán, inglés o español), CSV o ZIP con recibos.",
  "tour.calendarTitle": "Calendario en dos direcciones",
  "tour.calendarBody": "Conecta Google Calendar: convierte eventos en viajes con un clic e igualmente envía viajes al calendario desde la tabla de Viajes.",
  "tour.settingsTitle": "Empieza por tu perfil",
  "tour.settingsBody": "En Ajustes → Perfil define tu tarifa por km y tu dirección base: sin ellas no hay importes ni distancia automática.",
  "tour.planTitle": "Tu plan y la cuota de IA",
  "tour.planBody": "Aquí ves tu plan actual. Pro amplía las extracciones de callsheets al mes y te deja usar tu propia clave de OpenRouter.",
  "tour.finalTitle": "¡Todo listo!",
  "tour.finalBody": "Cuando quieras repasar algo, tienes la documentación y este tutorial en Ajustes → Ayuda y docs. ¡Buen rodaje!",

  // Tutorial del modal de añadir/editar viaje (TripModalTour)
  "tripTour.help": "Tutorial del formulario",
  "tripTour.routeTitle": "La ruta del viaje",
  "tripTour.routeBody": "El origen parte de tu dirección base: si lo dejas vacío, se usa la dirección en gris. Escribe el destino y elige una sugerencia; con \"Añadir parada\" metes hasta 25 paradas y las reordenas arrastrando.",
  "tripTour.originModeTitle": "Origen especial: encadena tu día",
  "tripTour.originModeBody": "\"Salida desde mi dirección base\" es el viaje normal desde casa. \"Continuar desde el último destino\" rellena el origen con el destino de tu viaje anterior — ideal para el segundo viaje del día. \"Regresar a mi dirección base\" fija el destino en tu base para la vuelta.",
  "tripTour.distanceTitle": "Distancia y tarifa",
  "tripTour.distanceBody": "La distancia se calcula sola con Google Maps al completar la ruta; puedes corregirla a mano o recalcular con el botón del medio. La tarifa es opcional: si la rellenas, manda sobre la del proyecto y la del perfil.",
  "tripTour.passengersTitle": "Pasajeros",
  "tripTour.passengersBody": "Indica cuántos compañeros llevaste: su suplemento por km se calcula aparte y va SIEMPRE separado del kilometraje, también en el informe.",
  "tripTour.expensesTitle": "Gastos con recibo",
  "tripTour.expensesBody": "Peaje, parking, combustible y otros: escribe el importe en EUR y adjunta la foto del recibo con el botón de la cámara. Van al informe como líneas propias.",
  "tripDetail.invoiceFailed": "Error",
  "tripDetail.invoiceNeedsReview": "Revisar",

  // Expense Scan
  "tripModal.expenses": "Gastos",
  "tripModal.expensesHintBefore": "Usa",
  "tripModal.expensesHintAfter": "para adjuntar la foto del recibo e introduce el importe manualmente en EUR. Recibos extranjeros (CZK/HUF): introduce el importe ya convertido a EUR.",
  "expenseScan.title": "Adjuntar recibo",
  "expenseScan.scanReceipt": "Adjuntar recibo",
  "expenseScan.typeToll": "Peaje",
  "expenseScan.typeParking": "Parking",
  "expenseScan.typeFuel": "Combustible",
  "expenseScan.typeOther": "Otro gasto",
  "expenseScan.processing": "Guardando recibo...",
  "expenseScan.error": "Error al extraer datos",
  "expenseScan.dataExtracted": "Datos extraídos",
  "expenseScan.amount": "Importe",
  "expenseScan.quantity": "Cantidad",
  "expenseScan.pricePerUnit": "Precio/unidad",
  "expenseScan.vendor": "Proveedor",
  "expenseScan.date": "Fecha",
  "expenseScan.cancel": "Cancelar",
  "expenseScan.extract": "Extraer datos",
  "expenseScan.attach": "Adjuntar recibo",
  "expenseScan.receiptAttached": "Recibo adjuntado",
  "expenseScan.retry": "Reintentar",
  "expenseScan.useData": "Usar datos",
  "expenseScan.invalidFileType": "Solo se permiten imágenes (JPG, PNG, WebP)",
  "expenseScan.fileTooLarge": "La imagen es demasiado grande (máx. 10MB)",
  "expenseScan.extracted": "Datos extraídos correctamente",
  "expenseScan.canEditAfter": "Puedes editar después de confirmar",
  "expenseScan.rotateImage": "Rotar imagen",
  "expenseScan.noDataExtracted": "No se pudo extraer el importe. Asegúrate de que el recibo sea legible.",
  "expenseScan.uploadError": "Error al subir la imagen",
  "expenseScan.dragDropText": "Arrastra y suelta la imagen aquí",
  "expenseScan.clickToUpload": "o haz clic para seleccionar",
  "expenseScan.useCamera": "Usar cámara",
  "expenseScan.uploadFile": "Subir archivo",
  "expenseScan.errorNotAuthenticated": "Sesión expirada. Por favor, vuelve a iniciar sesión.",
  "expenseScan.errorQuotaExceeded": "Has alcanzado el límite mensual de extracciones IA.",
  "expenseScan.errorFileNotFound": "No se encontró el archivo. Inténtalo de nuevo.",
  "expenseScan.errorServer": "Error del servidor. Inténtalo de nuevo en unos minutos.",
  "expenseScan.viewReceipt": "Ver recibo",
  "expenseScan.viewReceipts": "Ver recibos",
  "expenseScan.deleteReceipt": "Eliminar recibo",
  "expenseScan.receiptDeleted": "Recibo eliminado correctamente",
  "expenseScan.deleteError": "Error al eliminar el recibo",
  "expenseScan.uploadedReceipts": "Recibos subidos",
  "expenseScan.receipt": "Recibo",
  "expenseScan.addMoreReceipts": "Puedes añadir más recibos",
  "expenseScan.addAnotherReceipt": "Añadir otro recibo",

  // Plans page
  "nav.plans": "Planes",
  "plans.title": "Elige tu plan",
  "plans.subtitle": "Tus viajes organizados por proyecto y el Kilometergeld listo para producción y para el fisco.",
  "plans.billingMonthly": "Mensual",
  "plans.billingAnnual": "Anual",
  "plans.annualBadge": "-54 %",
  "plans.perYear": "al año",
  "plans.annualEquiv": "Equivale a 4,17 €/mes — ahorra un 54 %",
  "plans.cancelAnytime": "Sin permanencia: cancela cuando quieras.",
  "plans.basic.name": "Gratuito",
  "plans.basic.description": "Organiza viajes e informes ilimitados, gratis para siempre.",
  "plans.pro.name": "Pro",
  "plans.pro.description": "Vuelca tus callsheets y factura sin teclear nada.",
  "plans.forever": "para siempre",
  "plans.perMonth": "al mes",
  "plans.currentPlan": "Plan actual",
  "plans.upgradeToPro": "Actualizar a Pro",
  "plans.mostPopular": "Más popular",
  "plans.sidebar.free": "Plan Gratuito",
  "plans.sidebar.upgrade": "Actualizar a Pro",
  "plans.sidebar.manage": "Gestionar plan",
  "plans.features.trips20": "20 viajes activos",
  "plans.features.trips2000": "2000 viajes activos",
  "plans.features.unlimitedTrips": "Viajes ilimitados",
  "plans.features.projects3": "3 proyectos",
  "plans.features.projects30": "30 proyectos",
  "plans.features.unlimitedProjects": "Proyectos ilimitados",
  "plans.features.ai5": "5 extracciones IA/mes",
  "plans.features.ai3": "3 callsheets IA/mes",
  "plans.features.ai60": "60 callsheets IA/mes",
  "plans.features.ai400Annual": "400 callsheets IA por año de suscripción",
  "plans.features.customAI": "Extracciones IA personalizadas",
  "plans.features.stops10": "10 paradas por viaje",
  "plans.features.stops25": "25 paradas por viaje",
  "plans.features.unlimitedStops": "Paradas ilimitadas",
  "plans.features.csvExport": "Exportación CSV",
  "plans.features.allExports": "Todas las exportaciones",
  "plans.features.basicReports": "Informes básicos",
  "plans.features.advancedReports": "Informes avanzados",
  "plans.features.customReports": "Informes personalizados",
  "plans.features.calendarSync": "Sincronización con Calendar",
  "plans.features.noCalendarSync": "Sin sincronización con Calendar",
  "plans.features.routeTemplates": "Plantillas de ruta",
  "plans.features.routeTemplates5": "5 plantillas de ruta",
  "plans.features.routeTemplates50": "50 plantillas de ruta",
  "plans.features.unlimitedTemplates": "Plantillas ilimitadas",
  "plans.features.costAnalysis": "Análisis de costes",
  "plans.features.fullAnalytics": "Analíticas completas",
  "plans.features.prioritySupport": "Soporte prioritario",
  "plans.features.dedicatedSupport": "Soporte dedicado",
  "plans.features.sla": "SLA garantizado",
  "plans.features.customIntegrations": "Integraciones personalizadas",
  "plans.features.reports1": "1 informe guardado",
  "plans.features.reportsUnlimited": "Informes ilimitados",
  "plans.features.callsheet1": "1 callsheet a la vez",
  "plans.features.callsheetBulk20": "Hasta 20 callsheets por subida",
  "plans.features.callsheetBatch3": "Hasta 3 callsheets por subida",
  "plans.features.byoOpenrouter": "Tu clave de OpenRouter: elige el modelo de IA (multimodal)",
  "plans.upgradeButton": "Actualizar a Pro",
  "plans.checkoutSuccess": "Pago completado. Estamos activando tu plan Pro.",
  "plans.checkoutCancelled": "El pago se canceló y no se realizó ningún cargo.",
  "plans.checkoutError": "No se pudo abrir el pago seguro de Stripe.",
  "plans.portalError": "No se pudo abrir la gestión de la suscripción.",

  // Odómetro (cuentakilómetros) — solo plan Pro
  "settings.tabOdometer": "Odómetro",
  "odometer.title": "Odómetro",
  "odometer.subtitle": "Lecturas de cuentakilómetros",
  "odometer.addReading": "+ Añadir lectura",
  "odometer.date": "Fecha",
  "odometer.readingKm": "Lectura (km)",
  "odometer.source": "Fuente",
  "odometer.notes": "Notas",
  "odometer.photo": "Foto",
  "odometer.totalKm": "Total km del periodo",
  "odometer.workKm": "Km laborales",
  "odometer.privateKm": "Km privados",
  "odometer.workPct": "Uso laboral",
  "odometer.proOnly": "Función Pro",
  "odometer.proOnlyBody": "El seguimiento del odómetro es una función Pro para calcular el ratio km laborales/privados (Finanzamt/Hacienda).",
  "odometer.upgradeCta": "Ver planes",
  "odometer.sourceItv": "ITV / TÜV",
  "odometer.sourceTaller": "Taller / Mantenimiento",
  "odometer.sourceSeguro": "Seguro",
  "odometer.sourceManual": "Entrada manual",
  "odometer.extractingAi": "Extrayendo km con IA…",
  "odometer.extractedByAi": "IA",
  "odometer.editedManual": "Manual",
  "odometer.userEdited": "Corregido",
  "odometer.correctionNoteLabel": "Motivo de la corrección",
  "odometer.correctionNotePlaceholder": "Ej: error de extracción IA, valor corregido manualmente",
  "odometer.editKmLabel": "Editar valor km",
  "odometer.toastCorrected": "Valor actualizado",
  "odometer.userModifiedTag": "mod. manual",
  "odometer.extractionFailed": "Fallo IA — edita manualmente",
  "odometer.deleteConfirm": "¿Eliminar esta lectura de odómetro?",
  "odometer.noSnapshots": "Aún no tienes lecturas. Sube la primera foto del cuentakilómetros.",
  "odometer.oneSnapshot": "✓ Primera lectura guardada. Añade una segunda para ver el cálculo de ratio.",
  "odometer.calcTitle": "Odómetro — desglose km",
  "odometer.yearLabel": "Año",
  "odometer.toastAdded": "Lectura añadida",
  "odometer.toastDeleted": "Lectura eliminada",
  "odometer.toastSaveError": "Error al guardar la lectura",
  "odometer.toastExtractError": "Error en la extracción IA. Introduce el km manualmente.",
  "odometer.thumbnailAlt": "Foto del odómetro",
  "odometer.dialogTitle": "Añadir lectura de odómetro",
  "odometer.dialogSave": "Guardar lectura",
  "odometer.pctLabel": "{pct}% uso laboral",
  "odometer.qrButton": "Usar cámara del móvil",
  "odometer.qrTitle": "Escanea con tu teléfono",
  "odometer.qrBody": "Abre la cámara de tu móvil y escanea el código QR para fotografiar el odómetro directamente con tu teléfono.",
  "odometer.qrWaiting": "Esperando foto del móvil…",
  "odometer.qrSuccess": "¡Foto recibida! Procesando con IA…",
  "odometer.qrExpiredModal": "El código ha caducado. Cierra y vuelve a intentarlo.",
  "odometer.captureTitle": "Fotografía del odómetro",
  "odometer.captureInstructions": "Apunta la cámara al panel del cuentakilómetros y asegúrate de que los números sean claramente visibles.",
  "odometer.captureTakePhoto": "Tomar foto con cámara",
  "odometer.captureSubmit": "Enviar foto",
  "odometer.captureSuccess": "✓ ¡Foto enviada! Puedes cerrar esta ventana.",
  "odometer.captureError": "Error al enviar la foto. Vuelve a intentarlo.",
  "odometer.captureExpired": "Este enlace ha caducado. Genera un nuevo código QR desde el ordenador.",
  "odometer.captureLoading": "Preparando…",
  "odometer.captureOr": "O elige de la galería",

} as const;

export type I18nKey = keyof typeof es;
